(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4b09"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4b09"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cV1uQ", function(module, exports) {

$parcel$export(module.exports, "spawnTrackingEventListners", function () { return $b80dbd7b77187c82$export$3686817ae6f601e6; });

var $i928P = parcelRequire("i928P");
const $b80dbd7b77187c82$var$anchorAsButtonClick = ($element)=>{
    const anchorURL = $element instanceof HTMLAnchorElement ? $element.href : '';
    const buttonLabel = $element.textContent || '';
    (0, $i928P.pushDataLayer)('click_button', {
        button_type: 'Button',
        button_text: buttonLabel,
        button_url: anchorURL,
        button_src: window.location.href
    });
};
const $b80dbd7b77187c82$var$sliderAnchorClick = ($element)=>{
    const anchorURL = $element instanceof HTMLAnchorElement ? $element.href : '';
    const buttonLabel = $element.textContent || '';
    (0, $i928P.pushDataLayer)('click_button', {
        button_type: 'Slider',
        button_text: buttonLabel,
        button_url: anchorURL,
        button_src: window.location.href
    });
};
const $b80dbd7b77187c82$var$handleTrackingAction = (event)=>{
    const element = event.currentTarget;
    const trackingID = element.getAttribute('data-track-click');
    switch(trackingID){
        case 'anchor-button':
            return $b80dbd7b77187c82$var$anchorAsButtonClick(element);
        case 'slider-button':
            return $b80dbd7b77187c82$var$sliderAnchorClick(element);
        default:
            return console.warn('Unhandled tracking event');
    }
};
function $b80dbd7b77187c82$export$3686817ae6f601e6() {
    const $trackedButtons = document.querySelectorAll('[data-track-click]');
    for (const $singleButton of $trackedButtons)$singleButton.addEventListener('click', $b80dbd7b77187c82$var$handleTrackingAction);
}

});
parcelRegister("i928P", function(module, exports) {

$parcel$export(module.exports, "pushDataLayer", function () { return $9098f0eb9e4bc73b$export$d63e23ced30638e5; });
function $9098f0eb9e4bc73b$export$d63e23ced30638e5(eventName, eventParams) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ...eventParams
    });
}

});


parcelRegister("1QOFx", function(module, exports) {

$parcel$export(module.exports, "handleHasAccountInputs", function () { return $42848b58cf199cec$export$be0292208ac25033; });
function $42848b58cf199cec$export$be0292208ac25033() {
    const $hasAccountInputs = document.querySelectorAll('input[name="has-account"]');
    if ($hasAccountInputs) {
        const $hasAccount = document.querySelector('#has-account-container');
        const $hasNotAccount = document.querySelector('#has-not-account-container');
        $hasAccountInputs.forEach((input)=>{
            input.addEventListener('click', ()=>{
                if (input.checked) {
                    const dataAccount = input.getAttribute('data-account');
                    if (dataAccount === 'has-account') {
                        $hasAccount.hidden = false;
                        $hasNotAccount.hidden = true;
                    } else {
                        $hasAccount.hidden = true;
                        $hasNotAccount.hidden = false;
                    }
                }
            });
        });
    }
}

});

parcelRegister("bRcVd", function(module, exports) {

$parcel$export(module.exports, "handleCompetitionForm", function () { return $efcb327731767364$export$71b3ccb20f09b3a7; });

var $daEfo = parcelRequire("daEfo");

var $cctvf = parcelRequire("cctvf");

var $858k1 = parcelRequire("858k1");

var $lljZm = parcelRequire("lljZm");

var $a6hcg = parcelRequire("a6hcg");
const $efcb327731767364$var$$submitFormButton = document.querySelector('[data-submit-button]');
const $efcb327731767364$var$$emailInputElement = document.querySelector("input[name='email']");
const $efcb327731767364$var$$serviceTermsInputElement = document.querySelector("input[name='reg-consent']");
const $efcb327731767364$var$$promotionTermsInputElement = document.querySelector("input[name='prom-consent']");
const $efcb327731767364$var$$marketingConsentInputElement = document.querySelector("input[name='marketing-consent']");
const $efcb327731767364$var$$eventInputElement = document.querySelector("input[name='competition']");
const $efcb327731767364$var$$answerElement = document.querySelector("textarea[name='answer']");
const $efcb327731767364$var$$allErrorSpans = document.querySelectorAll('[data-error]');
const $efcb327731767364$var$$allErrorCheckboxSpans = document.querySelectorAll('[data-checkbox-error]');
const $efcb327731767364$var$getEmailFromForm = ()=>$efcb327731767364$var$$emailInputElement?.value.trim();
const $efcb327731767364$var$getServiceTermConsent = ()=>$efcb327731767364$var$$serviceTermsInputElement ? $efcb327731767364$var$$serviceTermsInputElement.checked : true;
const $efcb327731767364$var$getPromotionTermConsent = ()=>$efcb327731767364$var$$promotionTermsInputElement ? $efcb327731767364$var$$promotionTermsInputElement?.checked : true;
const $efcb327731767364$var$getMarketingConsent = ()=>$efcb327731767364$var$$marketingConsentInputElement ? $efcb327731767364$var$$marketingConsentInputElement.checked : false;
const $efcb327731767364$var$getAnswerFromForm = ()=>$efcb327731767364$var$$answerElement?.value.trim();
const $efcb327731767364$var$getEvent = ()=>$efcb327731767364$var$$eventInputElement?.value.trim();
const $efcb327731767364$var$showCheckboxError = (errorID)=>{
    const $errorElement = document.querySelector(`[data-checkbox-error='${errorID}']`);
    if ($errorElement) $errorElement.hidden = false;
};
const $efcb327731767364$var$showError = ($element, errorID)=>{
    const $errorElement = document.querySelector(`[data-error='${errorID}']`);
    if ($element) $element.classList.add('is-error');
    if ($errorElement) $errorElement.hidden = false;
};
const $efcb327731767364$var$resetAllErrors = ()=>{
    $efcb327731767364$var$$emailInputElement?.classList.remove('is-error');
    $efcb327731767364$var$$answerElement?.classList.remove('is-error');
    for (const $singleErrorSpan of $efcb327731767364$var$$allErrorSpans)$singleErrorSpan.hidden = true;
    for (const $singleErrorCheckboxSpan of $efcb327731767364$var$$allErrorCheckboxSpans)$singleErrorCheckboxSpan.hidden = true;
};
const $efcb327731767364$var$checkIsEmailRegistered = async (email)=>{
    try {
        const emailResponse = await (0, $lljZm.checkEmailAvailability)({
            email: email
        });
        if ('available' in emailResponse) return !emailResponse.available;
        return null;
    } catch (error) {
        return null;
    }
};
const $efcb327731767364$var$checkEmailValidation = async (emailMustBeRegistered)=>{
    const email = $efcb327731767364$var$getEmailFromForm();
    if ((0, $cctvf.emptyValidator)(email)) {
        $efcb327731767364$var$showError($efcb327731767364$var$$emailInputElement, 'email-mandatory');
        return false;
    }
    if ((0, $cctvf.emailValidator)(email)) {
        $efcb327731767364$var$showError($efcb327731767364$var$$emailInputElement, 'email-invalid');
        return false;
    }
    if (emailMustBeRegistered) {
        const isEmailRegistered = await $efcb327731767364$var$checkIsEmailRegistered(email);
        if (!isEmailRegistered) {
            $efcb327731767364$var$showError($efcb327731767364$var$$emailInputElement, 'email-not-exist');
            return false;
        }
    }
    return true;
};
const $efcb327731767364$var$checkAnswerValidation = ()=>(0, $cctvf.emptyValidator)($efcb327731767364$var$getAnswerFromForm()) ? ($efcb327731767364$var$showError($efcb327731767364$var$$answerElement, 'answer-mandatory'), false) : true;
const $efcb327731767364$var$checkTermsOfServiceValidation = ()=>(0, $cctvf.checkedValidator)($efcb327731767364$var$getServiceTermConsent()) ? ($efcb327731767364$var$showCheckboxError('reg-consent-mandatory'), false) : true;
const $efcb327731767364$var$checkPromotionTermsValidation = ()=>(0, $cctvf.checkedValidator)($efcb327731767364$var$getPromotionTermConsent()) ? ($efcb327731767364$var$showCheckboxError('prom-consent-mandatory'), false) : true;
const $efcb327731767364$var$isFormComplete = async (emailMustBeRegistered, answerOptional)=>{
    return [
        await $efcb327731767364$var$checkEmailValidation(emailMustBeRegistered),
        answerOptional || $efcb327731767364$var$checkAnswerValidation(),
        $efcb327731767364$var$checkTermsOfServiceValidation(),
        $efcb327731767364$var$checkPromotionTermsValidation()
    ].every((v)=>v);
};
const $efcb327731767364$var$successSubmit = ()=>{
    const $formContent = document.querySelector('[data-form-content]');
    const $formTitle = document.querySelector('[data-form-title]');
    const $formSubTitle = document.querySelector('[data-form-subtitle]');
    const $submitButton = document.querySelector('[data-submit-button]');
    if ($formContent) $formContent.hidden = true;
    if ($formSubTitle) $formSubTitle.hidden = true;
    if ($formTitle) $formTitle.textContent = (0, $daEfo.t9n)('landingForm.competitionFormThanks');
    if ($submitButton) $submitButton.hidden = true;
};
const $efcb327731767364$var$handleFormSubmit = async (emailMustBeRegistered, answerOptional)=>{
    $efcb327731767364$var$resetAllErrors();
    if (await $efcb327731767364$var$isFormComplete(emailMustBeRegistered, answerOptional)) {
        const payload = {
            email: $efcb327731767364$var$getEmailFromForm(),
            event: $efcb327731767364$var$getEvent(),
            date: new Date().toISOString(),
            terms_and_conditions_accepted: $efcb327731767364$var$getPromotionTermConsent(),
            ...answerOptional ? {} : {
                answer: $efcb327731767364$var$getAnswerFromForm()
            }
        };
        (0, $858k1.default)(payload).then(()=>{
            if ($efcb327731767364$var$getMarketingConsent()) (0, $a6hcg.signUpForNewsletter)({
                email: $efcb327731767364$var$getEmailFromForm()
            });
            $efcb327731767364$var$successSubmit();
        }).catch((e)=>{
            const JSONResponse = JSON.parse(e.responseText);
            if (JSONResponse.error) $efcb327731767364$var$showError(null, 'general-invalid');
        });
    }
};
function $efcb327731767364$export$71b3ccb20f09b3a7(emailMustBeRegistered = false, answerOptional = false) {
    $efcb327731767364$var$$submitFormButton.addEventListener('click', ()=>$efcb327731767364$var$handleFormSubmit(emailMustBeRegistered, answerOptional));
}

});
parcelRegister("daEfo", function(module, exports) {

$parcel$export(module.exports, "t9n", function () { return $e2646c1083b46083$export$16fe4e029e1132f8; });
$parcel$export(module.exports, "getTranslationsMap", function () { return $e2646c1083b46083$export$1bec3765872667b0; });

var $7iiIP = parcelRequire("7iiIP");

var $kDmAn = parcelRequire("kDmAn");

var $21DfC = parcelRequire("21DfC");

var $5xn28 = parcelRequire("5xn28");

var $2GJ0A = parcelRequire("2GJ0A");

var $7eQgT = parcelRequire("7eQgT");
const $e2646c1083b46083$var$translations = {
    [(0, $kDmAn.SupportedLanguages).pl]: (0, $21DfC.default),
    [(0, $kDmAn.SupportedLanguages).en]: (0, $5xn28.default),
    [(0, $kDmAn.SupportedLanguages).ru]: (0, $2GJ0A.default),
    [(0, $kDmAn.SupportedLanguages).ua]: (0, $7eQgT.default)
};
const $e2646c1083b46083$var$getNestedValue = (obj, path)=>{
    return path.reduce((acc, key)=>{
        if (acc && typeof acc === 'object') return acc[key];
        return undefined;
    }, obj);
};
const $e2646c1083b46083$var$interpolate = (str, vars = {})=>{
    return str.replace(/{{\s*(\w+)\s*}}/g, (_, key)=>vars[key] ?? '');
};
const $e2646c1083b46083$export$16fe4e029e1132f8 = (key, vars, lang = (0, $7iiIP.getCurrentLanguage)())=>{
    const messages = $e2646c1083b46083$var$translations[lang] || $e2646c1083b46083$var$translations[(0, $kDmAn.SupportedLanguages).pl];
    const path = key.split('.');
    const raw = $e2646c1083b46083$var$getNestedValue(messages, path);
    return raw ? $e2646c1083b46083$var$interpolate(raw, vars) : key;
};
const $e2646c1083b46083$export$1bec3765872667b0 = (lang = (0, $7iiIP.getCurrentLanguage)())=>{
    return $e2646c1083b46083$var$translations[lang] || $e2646c1083b46083$var$translations[(0, $kDmAn.SupportedLanguages).pl];
};

});
parcelRegister("7iiIP", function(module, exports) {

$parcel$export(module.exports, "getLangFromUrl", function () { return $e808b7286267199c$export$5803c3c1cacc7a03; });
$parcel$export(module.exports, "getCurrentLanguage", function () { return $e808b7286267199c$export$604ba5624273df44; });

var $jey7f = parcelRequire("jey7f");

var $kDmAn = parcelRequire("kDmAn");

var $gXaPs = parcelRequire("gXaPs");
const $e808b7286267199c$var$isBrowser = typeof window !== 'undefined';
const $e808b7286267199c$export$e7bdde1845b77176 = ()=>{
    if (!$e808b7286267199c$var$isBrowser) return null;
    try {
        const cookieLang = (0, $jey7f.default)?.getItem('language');
        return (0, $kDmAn.isSupportedLanguage)(cookieLang) ? cookieLang : null;
    } catch (error) {
        console.error('Error getting language from cookie:', error);
        return null;
    }
};
const $e808b7286267199c$export$5803c3c1cacc7a03 = ()=>{
    if (!$e808b7286267199c$var$isBrowser) return null;
    const hostname = window.location.hostname;
    if (hostname.startsWith('en.')) return (0, $kDmAn.SupportedLanguages).en;
    if (hostname.startsWith('ru.')) return (0, $kDmAn.SupportedLanguages).ru;
    if (hostname.startsWith('ua.')) return (0, $kDmAn.SupportedLanguages).ua;
    return (0, $kDmAn.SupportedLanguages).pl;
};
const $e808b7286267199c$export$b45fa50bf92adae6 = ()=>{
    const langFromEnv = $gXaPs?.env?.LANGUAGE;
    if (!langFromEnv) return null;
    return (0, $kDmAn.isSupportedLanguage)(langFromEnv) ? langFromEnv : null;
};
const $e808b7286267199c$var$getInitialLanguage = ()=>$e808b7286267199c$export$e7bdde1845b77176() || $e808b7286267199c$export$5803c3c1cacc7a03();
function $e808b7286267199c$export$604ba5624273df44() {
    const detectedLang = !$e808b7286267199c$var$isBrowser ? $e808b7286267199c$export$b45fa50bf92adae6() : $e808b7286267199c$var$getInitialLanguage();
    if (detectedLang) return detectedLang;
    const source = !$e808b7286267199c$var$isBrowser ? 'server environment' : 'cookie or URL';
    console.warn(`[getCurrentLanguage] Could not get language from ${source}, using default language:`, (0, $kDmAn.DEFAULT_LANGUAGE));
    return 0, $kDmAn.DEFAULT_LANGUAGE;
}

});
parcelRegister("jey7f", function(module, exports) {

$parcel$export(module.exports, "getAllowedCookies", function () { return $d0a7903e4974b019$export$78bb765b962664de; });
$parcel$export(module.exports, "getCookieDomain", function () { return $d0a7903e4974b019$export$79fcbe1b192cd706; });
$parcel$export(module.exports, "default", function () { return $d0a7903e4974b019$export$2e2bcd8739ae039; });

var $bg4xJ = parcelRequire("bg4xJ");

var $kDmAn = parcelRequire("kDmAn");
const $d0a7903e4974b019$export$78bb765b962664de = (allowedCookies)=>{
    const cookiesArray = {};
    allowedCookies.forEach((item)=>{
        const cookieValue = $d0a7903e4974b019$var$cookieService.getItem(item);
        if (cookieValue) cookiesArray[item] = cookieValue;
    });
    return cookiesArray;
};
const $d0a7903e4974b019$export$79fcbe1b192cd706 = (domain)=>{
    const regex = new RegExp(`^(${(0, $kDmAn.LANGUAGE_SUBDOMAINS).join('|')})\\.`);
    return (domain || location.hostname).replace(regex, '');
};
const $d0a7903e4974b019$var$cookieService = {
    maximalCookieTTL: 90,
    setItem: (key, value, days = 365, domain = '', sameSite = 'Lax')=>{
        const currentDate = new Date();
        currentDate.setTime(+currentDate + days * 86400000);
        document.cookie = `${key}=${value}; path=/; domain=${$d0a7903e4974b019$export$79fcbe1b192cd706(domain)}; expires=${currentDate.toUTCString()}; SameSite=${sameSite}; Secure`;
    },
    getItem: (name)=>{
        if (!document.cookie) return null;
        const cookies = document.cookie.split('; ');
        const cookie = cookies.find((cookie)=>cookie.startsWith(`${name}=`));
        if (!cookie) return null;
        return cookie.substring(name.length + 1);
    },
    removeItem (key, domain) {
        if (document.cookie) {
            const zeroTime = new Date(0);
            document.cookie = `${key}=; expires=${zeroTime.toUTCString()}${domain ? `; domain=${domain}` : ''}; path=/`;
        }
    },
    extractParamsFromURL: ()=>{
        const params = new URLSearchParams(window.location.search);
        const vars = {};
        params.forEach((value, key)=>{
            vars[key] = value;
        });
        return vars;
    },
    setCookieByParamUrl (paramKey, cookieKey) {
        const urlParamsObject = (0, $bg4xJ.getParamsFromUrl)();
        if ((0, $bg4xJ.doesUrlContainParam)(paramKey, urlParamsObject)) $d0a7903e4974b019$var$cookieService.setItem(cookieKey, urlParamsObject[paramKey], $d0a7903e4974b019$var$cookieService.maximalCookieTTL);
    },
    setupCookiesFromURL: (allowedParams)=>{
        const paramsToStore = $d0a7903e4974b019$var$cookieService.extractParamsFromURL();
        for(const paramName in paramsToStore)if ((0, $bg4xJ.doesUrlContainParam)(paramName, paramsToStore) && allowedParams.includes(paramName)) {
            const cookieName = paramName === 'xchangerId' ? 'xchanger_id' : paramName;
            $d0a7903e4974b019$var$cookieService.setItem(cookieName, paramsToStore[paramName], $d0a7903e4974b019$var$cookieService.maximalCookieTTL);
        }
    },
    setupCookiesFromClient: ()=>{
        if ($d0a7903e4974b019$var$cookieService.getItem('ik_referrer')) // TODO: Check is this code relevant for us.
        $d0a7903e4974b019$var$cookieService.setItem('ik_referrer', document.referrer);
    }
};
var $d0a7903e4974b019$export$2e2bcd8739ae039 = $d0a7903e4974b019$var$cookieService;

});
parcelRegister("bg4xJ", function(module, exports) {

$parcel$export(module.exports, "isPanelUrl", function () { return $265222550428d748$export$20980cc1374e1b8c; });
$parcel$export(module.exports, "doesUrlContainParam", function () { return $265222550428d748$export$902ed42de98921ac; });
$parcel$export(module.exports, "getParamsFromUrl", function () { return $265222550428d748$export$9b6f748a4c74bb77; });
$parcel$export(module.exports, "removeUrlParams", function () { return $265222550428d748$export$4f9c066ec897736f; });
$parcel$export(module.exports, "renameQueryParam", function () { return $265222550428d748$export$e16de3bdbb617fe2; });
$parcel$export(module.exports, "decodeUrlParams", function () { return $265222550428d748$export$f002049d3814fdfc; });
$parcel$export(module.exports, "createUrlWithParams", function () { return $265222550428d748$export$a8593f22bf2d4f51; });

var $7iiIP = parcelRequire("7iiIP");

var $kDmAn = parcelRequire("kDmAn");
const $265222550428d748$export$20980cc1374e1b8c = (url)=>url.hostname.includes('klient.') || url.hostname.includes('panel.') || url.pathname.startsWith('/logowanie');
const $265222550428d748$export$902ed42de98921ac = (key, urlParamsObject)=>{
    urlParamsObject = urlParamsObject || $265222550428d748$export$9b6f748a4c74bb77();
    return !!urlParamsObject[key];
};
const $265222550428d748$export$9b6f748a4c74bb77 = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    return Array.from(urlParams.keys()).length > 0 ? Object.fromEntries(urlParams.entries()) : {};
};
const $265222550428d748$export$b8eaffbd63e11c5f = (key)=>{
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(key) ? urlParams.get(key) : null;
};
const $265222550428d748$export$4f9c066ec897736f = (url, paramsToRemove)=>{
    const urlObj = new URL(url);
    const searchParams = urlObj.searchParams;
    paramsToRemove.forEach((param)=>searchParams.delete(param));
    return urlObj.origin + urlObj.pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '') + urlObj.hash;
};
function $265222550428d748$export$e16de3bdbb617fe2(fromParam, toParam) {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    if (params.has(fromParam)) {
        const value = params.get(fromParam);
        params.delete(fromParam);
        params.set(toParam, value || '');
        const newUrl = `${currentUrl.pathname}?${params.toString()}${currentUrl.hash}`;
        window.history.replaceState({}, '', newUrl);
    }
}
const $265222550428d748$export$f002049d3814fdfc = (url)=>{
    try {
        const { search: search, hash: hash } = new URL(url);
        const searchParams = Object.fromEntries(new URLSearchParams(search).entries());
        const paramsString = hash.startsWith('#/?') ? hash.slice(2) : '';
        const encodedParams = paramsString ? new URLSearchParams(paramsString).get('data') : null;
        let decodedParams = {};
        if (encodedParams) {
            decodedParams = JSON.parse(decodeURIComponent(encodedParams));
            decodedParams = Array.isArray(decodedParams) ? Object.assign({}, ...decodedParams) : decodedParams;
        }
        return {
            ...searchParams,
            ...decodedParams
        };
    } catch (error) {
        console.error('Error decoding URL params:', error);
        return {};
    }
};
const $265222550428d748$export$a8593f22bf2d4f51 = (cookiesToParam, url)=>{
    const newUrl = new URL(url);
    const cookieParams = new URLSearchParams(Object.entries(cookiesToParam).map(([key, value])=>[
            key,
            String(value)
        ]));
    if (!$265222550428d748$export$20980cc1374e1b8c(newUrl)) {
        newUrl.search = cookieParams.toString();
        return newUrl.toString();
    }
    newUrl.searchParams.delete('lang');
    if (cookieParams.has('language')) {
        newUrl.searchParams.set('lang', cookieParams.get('language'));
        cookieParams.delete('language');
    } else newUrl.searchParams.set('lang', (0, $7iiIP.getCurrentLanguage)());
    const remainingParams = cookieParams.toString();
    if (remainingParams) {
        const hash = newUrl.hash || '#/';
        const separator = hash.includes('?') ? '&' : '?';
        newUrl.hash = `${hash}${separator}${remainingParams}`;
    } else if (!newUrl.hash) newUrl.hash = '#/';
    return newUrl.toString();
};
function $265222550428d748$export$304e24f68705812f(param, value) {
    if (param.type === 'boolean') try {
        return JSON.parse(value) === true || JSON.parse(value) === false;
    } catch (e) {
        return false;
    }
    if (param.type === 'string') {
        if (typeof value !== 'string' || value === 'true' || value === 'false') return false;
        if (param.name === 'lang' && param.allowedValues) {
            const allowedLanguages = Object.values((0, $kDmAn.SupportedLanguages));
            return allowedLanguages.includes(value);
        }
        return true;
    }
    return false;
}

});
parcelRegister("kDmAn", function(module, exports) {

$parcel$export(module.exports, "SupportedLanguages", function () { return $996c0b2716149a12$export$fcdd902bf6e4111a; });
$parcel$export(module.exports, "DEFAULT_LANGUAGE", function () { return $996c0b2716149a12$export$910b680d1eea6990; });
$parcel$export(module.exports, "LANGUAGE_SUBDOMAINS", function () { return $996c0b2716149a12$export$f09a0a51279e987d; });
$parcel$export(module.exports, "isSupportedLanguage", function () { return $996c0b2716149a12$export$47c66070d6d6cd6d; });
var $996c0b2716149a12$export$fcdd902bf6e4111a = /*#__PURE__*/ function(SupportedLanguages) {
    SupportedLanguages["pl"] = "pl";
    SupportedLanguages["en"] = "en";
    SupportedLanguages["ru"] = "ru";
    SupportedLanguages["ua"] = "ua";
    return SupportedLanguages;
}({});
const $996c0b2716149a12$export$910b680d1eea6990 = "pl";
const $996c0b2716149a12$export$f09a0a51279e987d = [
    "pl",
    "en",
    "ru",
    "ua"
];
const $996c0b2716149a12$export$47c66070d6d6cd6d = (lang)=>typeof lang === 'string' && Object.values($996c0b2716149a12$export$fcdd902bf6e4111a).includes(lang);

});



parcelRegister("gXaPs", function(module, exports) {
// shim for using process in browser
var $c57a8e741463be4d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $c57a8e741463be4d$var$cachedSetTimeout;
var $c57a8e741463be4d$var$cachedClearTimeout;
function $c57a8e741463be4d$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $c57a8e741463be4d$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $c57a8e741463be4d$var$cachedSetTimeout = setTimeout;
        else $c57a8e741463be4d$var$cachedSetTimeout = $c57a8e741463be4d$var$defaultSetTimout;
    } catch (e) {
        $c57a8e741463be4d$var$cachedSetTimeout = $c57a8e741463be4d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $c57a8e741463be4d$var$cachedClearTimeout = clearTimeout;
        else $c57a8e741463be4d$var$cachedClearTimeout = $c57a8e741463be4d$var$defaultClearTimeout;
    } catch (e) {
        $c57a8e741463be4d$var$cachedClearTimeout = $c57a8e741463be4d$var$defaultClearTimeout;
    }
})();
function $c57a8e741463be4d$var$runTimeout(fun) {
    if ($c57a8e741463be4d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($c57a8e741463be4d$var$cachedSetTimeout === $c57a8e741463be4d$var$defaultSetTimout || !$c57a8e741463be4d$var$cachedSetTimeout) && setTimeout) {
        $c57a8e741463be4d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c57a8e741463be4d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $c57a8e741463be4d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $c57a8e741463be4d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $c57a8e741463be4d$var$runClearTimeout(marker) {
    if ($c57a8e741463be4d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($c57a8e741463be4d$var$cachedClearTimeout === $c57a8e741463be4d$var$defaultClearTimeout || !$c57a8e741463be4d$var$cachedClearTimeout) && clearTimeout) {
        $c57a8e741463be4d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c57a8e741463be4d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $c57a8e741463be4d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $c57a8e741463be4d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $c57a8e741463be4d$var$queue = [];
var $c57a8e741463be4d$var$draining = false;
var $c57a8e741463be4d$var$currentQueue;
var $c57a8e741463be4d$var$queueIndex = -1;
function $c57a8e741463be4d$var$cleanUpNextTick() {
    if (!$c57a8e741463be4d$var$draining || !$c57a8e741463be4d$var$currentQueue) return;
    $c57a8e741463be4d$var$draining = false;
    if ($c57a8e741463be4d$var$currentQueue.length) $c57a8e741463be4d$var$queue = $c57a8e741463be4d$var$currentQueue.concat($c57a8e741463be4d$var$queue);
    else $c57a8e741463be4d$var$queueIndex = -1;
    if ($c57a8e741463be4d$var$queue.length) $c57a8e741463be4d$var$drainQueue();
}
function $c57a8e741463be4d$var$drainQueue() {
    if ($c57a8e741463be4d$var$draining) return;
    var timeout = $c57a8e741463be4d$var$runTimeout($c57a8e741463be4d$var$cleanUpNextTick);
    $c57a8e741463be4d$var$draining = true;
    var len = $c57a8e741463be4d$var$queue.length;
    while(len){
        $c57a8e741463be4d$var$currentQueue = $c57a8e741463be4d$var$queue;
        $c57a8e741463be4d$var$queue = [];
        while(++$c57a8e741463be4d$var$queueIndex < len)if ($c57a8e741463be4d$var$currentQueue) $c57a8e741463be4d$var$currentQueue[$c57a8e741463be4d$var$queueIndex].run();
        $c57a8e741463be4d$var$queueIndex = -1;
        len = $c57a8e741463be4d$var$queue.length;
    }
    $c57a8e741463be4d$var$currentQueue = null;
    $c57a8e741463be4d$var$draining = false;
    $c57a8e741463be4d$var$runClearTimeout(timeout);
}
$c57a8e741463be4d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $c57a8e741463be4d$var$queue.push(new $c57a8e741463be4d$var$Item(fun, args));
    if ($c57a8e741463be4d$var$queue.length === 1 && !$c57a8e741463be4d$var$draining) $c57a8e741463be4d$var$runTimeout($c57a8e741463be4d$var$drainQueue);
};
// v8 likes predictible objects
function $c57a8e741463be4d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$c57a8e741463be4d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$c57a8e741463be4d$var$process.title = 'browser';
$c57a8e741463be4d$var$process.browser = true;
$c57a8e741463be4d$var$process.env = {};
$c57a8e741463be4d$var$process.argv = [];
$c57a8e741463be4d$var$process.version = ''; // empty string to avoid regexp issues
$c57a8e741463be4d$var$process.versions = {};
function $c57a8e741463be4d$var$noop() {}
$c57a8e741463be4d$var$process.on = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.addListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.once = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.off = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.removeListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.removeAllListeners = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.emit = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.prependListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.prependOnceListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.listeners = function(name) {
    return [];
};
$c57a8e741463be4d$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$c57a8e741463be4d$var$process.cwd = function() {
    return '/';
};
$c57a8e741463be4d$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$c57a8e741463be4d$var$process.umask = function() {
    return 0;
};

});


parcelRegister("21DfC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $735476bfba0f5402$export$2e2bcd8739ae039; });
var $735476bfba0f5402$export$2e2bcd8739ae039 = {
    calculator: {
        buyLabelName: 'mam',
        swapButtonAriaLabel: "zamie\u0144 waluty miejscami",
        sellLabelName: 'otrzymam',
        currentRate: 'Aktualny kurs:',
        continueButton: "Kontynuuj wymian\u0119",
        miniChart: "Mini-wykres pokazuje wahania \u015Bredniego kursu z ostatnich 7 dni",
        sellTooltip: "To kurs sprzeda\u017Cy - sprzedajemy Ci {{currency}} po {{rate}} PLN. Im ni\u017Cszy kurs tym bardziej korzystny dla Ciebie. Automatyczna aktualizacja co 10 sekund.",
        buyTooltip: "To kurs kupna -kupujemy od Ciebie {{currency}} po {{rate}} PLN. Im wy\u017Cszy kurs tym bardziej korzystny dla Ciebie. Automatyczna aktualizacja co 10 sekund.",
        saleNotAvailableInfo: "Aktualnie sprzeda\u017C {{baseCurrency}} jest niedost\u0119pna",
        minAmount: 'Minimalna kwota wymiany to {{minAmount}} {{minCurrency}}.'
    },
    creditCalculator: {
        monthlyLoan: "Miesi\u0119czna rata kredytu",
        loanTerm: "Do ko\u0144ca kredytu pozosta\u0142o",
        whichBank: "W jakim banku sp\u0142acasz kredyt?",
        save: "Oszcz\u0119dzaj!",
        years: 'lat',
        inYear: "w ci\u0105gu roku",
        toEnd: "do ko\u0144ca kredytu",
        installmentAmount: "Kwota raty jest za ma\u0142a"
    },
    INTERNAL: "Pieni\u0105dze dojd\u0105 w oko\u0142o 30 minut od momentu kiedy otrzymamy Tw\xf3j przelew, najp\xf3\u017Aniej kolejnego dnia roboczego.",
    TODAY: "Pieni\u0105dze dojd\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
    TODAY_OUR: "Pieni\u0105dze dojd\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
    SEPA: "Pieni\u0105dze dojd\u0105 w ci\u0105gu 1 - 2 dni roboczych.",
    SEPA_INSTANT: "Pieni\u0105dze dojd\u0105 w oko\u0142o minut\u0119.",
    SPOT: "Pieni\u0105dze dojd\u0105 w ci\u0105gu 2 - 3 dni roboczych.",
    ELIXIR: "Pieni\u0105dze dojd\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
    LOCAL: "Pieni\u0105dze dojd\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego.",
    profitCalculator: {
        transferNotSupported: "Wybrany bank nie wspiera przelew\xf3w tej waluty.",
        transferFree: "Nie pobieramy \u017Cadnych op\u0142at za wys\u0142anie wymienionych \u015Brodk\xf3w!",
        transferFee: "Za przelew do wybranego przez Ciebie banku jest pobierana op\u0142ata bankowa \u2013 {{transferFee}} PLN. Op\u0142ata zosta\u0142a uwzgl\u0119dniona w wyliczeniu."
    },
    preactSelect: {
        search: 'Szukaj...'
    },
    newsletter: {
        alreadySubscribed: "Tw\xf3j mail znajduje si\u0119 ju\u017C w naszym newsletterze.",
        error: "Co\u015B posz\u0142o nie tak. Spr\xf3buj ponownie p\xf3\u017Aniej."
    },
    frontpageExitPopup: {
        accountExists: "Wygl\u0105da na to, \u017Ce masz ju\u017C konto. Zni\u017Ck\u0119 wysy\u0142amy dla nowych Klient\xf3w.",
        error: "Wyst\u0105pi\u0142 b\u0142\u0105d"
    },
    emailValidator: {
        requiredField: 'Konieczne jest zaznaczenie tego pola',
        notEmptyField: "To pole nie mo\u017Ce by\u0107 puste",
        minValue: "Minimalna warto\u015B\u0107 to",
        maxValue: "Makymalna warto\u015B\u0107 to",
        incorrectEmail: 'Podaj poprawny adres email',
        toShortPassword: "Has\u0142o jest za kr\xf3tkie"
    },
    currencyAlert: {
        isLower: "b\u0119dzie ni\u017Cszy",
        isHigher: "b\u0119dzie wy\u017Cszy",
        mustBeLessThan: "Kurs musi by\u0107 liczb\u0105 mniejsz\u0105 od 99,9999",
        alertAlreadyExists: "Alert kursowy dla podanego kursu ju\u017C istnieje",
        maxAlerts: "Nie mo\u017Cesz zapisa\u0107 si\u0119 na wi\u0119ksz\u0105 ilo\u015B\u0107 alert\xf3w. (max. 10)",
        error: "Co\u015B posz\u0142o nie tak, spr\xf3buj za chwil\u0119.",
        alertHash: 'alert-walutowy',
        averageRateNotAvailable: "Obecnie nie mo\u017Cemy ustawi\u0107 alertu, poniewa\u017C kurs {{currency}} jest tymczasowo niedost\u0119pny. ({{averageRate}})."
    },
    ratesUpdate: {
        update: "Trwa aktualizowanie kurs\xf3w...",
        success: "Nast\u0119pna aktualizacja kursu za",
        error: "Nie uda\u0142o si\u0119 pobra\u0107 danych. Ponawiam za"
    },
    currencyAnnotations: {
        notSupported: "Wymiana tej waluty nie jest obecnie mo\u017Cliwa"
    },
    currencies: {
        AED: 'Dirham ZEA',
        ARS: "Peso argenty\u0144skie",
        AUD: 'Dolar australijski',
        BDT: 'Taka bengalska',
        BGN: "Lew bu\u0142garski",
        BRL: 'Real brazylijski',
        CAD: 'Dolar kanadyjski',
        CHF: 'Frank szwajcarski',
        CLP: 'Peso chilijskie',
        CNY: "Juan chi\u0144ski",
        COP: 'Peso kolumbijskie',
        CZK: 'Korona czeska',
        DKK: "Korona du\u0144ska",
        EGP: 'Funt egipski',
        EUR: 'Euro',
        FJD: "Dolar fid\u017Ci",
        GBP: 'Funt brytyjski',
        GHS: "Cedi gha\u0144skie",
        HKD: "Dolar hongko\u0144ski",
        HUF: "Forint w\u0119gierski",
        ILS: 'Nowy szekel izraelski',
        INR: 'Rupia indyjska',
        JOD: "Dinar jorda\u0144ski",
        JPY: "Jen japo\u0144ski",
        KWD: 'Dinar kuwejcki',
        LSL: 'Loti lesotyjskie',
        MAD: "Dirham maroka\u0144ski",
        MXN: "Peso meksyka\u0144skie",
        NOK: 'Korona norweska',
        NPR: 'Rupia nepalska',
        NZD: 'Dolar nowozelandzki',
        OMR: "Rial oma\u0144ski",
        PEN: "Sol peruwia\u0144ski",
        PGK: "Kina papua\u0144ska",
        PLN: "Polski z\u0142oty",
        RON: "Leja rumu\u0144ska",
        RUB: 'Rubel rosyjski',
        SAR: 'Rial saudyjski',
        SEK: 'Korona szwedzka',
        SGD: 'Dolar singapurski',
        SZL: 'Lilangeni',
        THB: 'Bat tajlandzki',
        TRY: 'Lira turecka',
        USD: "Dolar ameryka\u0144ski",
        UYU: 'Peso urugwajskie',
        WST: "Tala samoa\u0144ska",
        ZAR: "Rand po\u0142udniowoafryka\u0144ski"
    },
    currenciesDopelniacz: {
        AED: 'Dirhama ZEA',
        ARS: "Peso argenty\u0144skiego",
        AUD: 'Dolara australijskiego',
        BDT: 'Taki banglijskiej',
        BGN: "Lewa bu\u0142garskiego",
        BRL: 'Reala brazylijskiego',
        CAD: 'Folara kanadyjskiego',
        CHF: 'Franka',
        CNY: "Juana chin\u015Bkiego",
        CZK: 'Korony czeskiej',
        DKK: "Korony du\u0144skiej",
        EGP: 'Funta egipskiego',
        EUR: 'Euro',
        FJD: "Dolara fid\u017Cyjskiego",
        GBP: 'Funta',
        GHS: "Cedi gha\u0144skiego",
        HKD: "Dolara hongko\u0144skiego",
        HUF: "Forinta w\u0119gierskiego",
        ILS: 'Szekla izraelskiego',
        INR: 'Rupii indyjskiej',
        JOD: "Dinara jorda\u0144skiego",
        JPY: "Jena japo\u0144skiego",
        KWD: 'Dinara kuwejckiego',
        LSL: 'Loti lesotyjskiej',
        MAD: "Dirhama maroka\u0144skiego",
        MXN: "Peso meksyka\u0144skiego",
        NOK: 'Korony norweskiej',
        NPR: 'Rupii nepalskiej',
        NZD: 'Dolara nowozelandzkiego',
        OMR: "Riala oma\u0144skiego",
        PEN: "Sol peruwia\u0144skiego",
        PGK: 'Kiny papuaskiej',
        PLN: "Z\u0142otego",
        RON: "Leja rumu\u0144skiego",
        RUB: 'Rubla rosyjskiego',
        SAR: 'Riala saudyjskiego',
        SEK: 'Korony szwedzkiej',
        SGD: 'Dolara singapurskiego',
        SZL: 'Lilangeni suazyjskiego',
        THB: 'Bata tajlandzkiego',
        TRY: 'Liry tureckiej',
        USD: 'Dolara',
        UYU: 'Peso urugwajskiego',
        WST: "Tali samoa\u0144skiej",
        ZAR: "Randa po\u0142udniowoafryka\u0144skiego"
    },
    chart: {
        time: 'Czas',
        rate: 'Kurs',
        opening: 'Otwarcie',
        highest: "Najwy\u017Cszy",
        lowest: "Najni\u017Cszy",
        closing: "Zamkni\u0119cie",
        monthNames: [
            'sty',
            'lut',
            'mar',
            'kwi',
            'maj',
            'cze',
            'lip',
            'sie',
            'wrz',
            "pa\u017A",
            'lis',
            'gru'
        ],
        dayNames: [
            'pon',
            'wto',
            "\u015Bro",
            'czw',
            "pi\u0105",
            'sob',
            'nie'
        ]
    },
    landingForm: {
        show: "Poka\u017C",
        hide: 'Ukryj',
        requiredField: 'Konieczne jest zaznaczenie tego pola',
        notEmptyField: "To pole nie mo\u017Ce by\u0107 puste",
        incorrectEmail: 'Podaj poprawny adres email',
        toShortPassword: "Has\u0142o jest za kr\xf3tkie",
        invalidPromocode: "Promocja dost\u0119pna na tej stronie si\u0119 sko\u0144czy\u0142a - zarejestruj si\u0119 przez stron\u0119 g\u0142\xf3wn\u0105",
        emailAlreadyExists: "Ten e&#8209;mail nie mo\u017Ce by\u0107 u\u017Cyty do rejestracji",
        generalInvalid: "Co\u015B posz\u0142o nie tak, spr\xf3buj ponownie p\xf3\u017Aniej",
        competitionFormThanks: "Dzi\u0119kujemy za udzia\u0142 w konkursie!"
    },
    networkErrorStatus: {
        slow: "Problem z pobraniem kurs\xf3w walut. Wolne po\u0142\u0105czenie z internetem.",
        noNetwork: "Problem z pobraniem kurs\xf3w walut. Sprawd\u017A czy masz po\u0142\u0105czenie z internetem.",
        default: "Wyst\u0105pi\u0142y problemy techniczne. Skontatuj si\u0119 z obs\u0142ug\u0105 klienta."
    },
    calculatorForegin: {
        continueButton: "Wy\u015Blij pieni\u0105dze",
        exchangeRates: 'Kurs wymiany',
        details: "Szczeg\xf3\u0142y",
        amountYouSend: "Kwota, kt\xf3r\u0105 wp\u0142acam",
        countryYouSendMoney: "Kraj, do kt\xf3rego wy\u015Blesz pieni\u0105dze",
        foreignTransferFee: "Op\u0142ata za przelew zagraniczny",
        foreignTransferType: 'Typ przelewu zagranicznego',
        exchangeAmount: 'Kwota wymiany',
        amountRecipientReceive: "Kwota, kt\xf3r\u0105 otrzyma odbiorca",
        minAmount: 'Kwota wymiany jest zbyt niska.',
        notSellCurrency: "Sprzeda\u017C waluty jest niedost\u0119pna.",
        transferTypes: {
            INTERNAL: {
                name: 'INTERNAL',
                desc: "Pieni\u0105dze dojd\u0105 w oko\u0142o 30 minut od momentu kiedy otrzymamy Tw\xf3j przelew, najp\xf3\u017Aniej kolejnego dnia roboczego."
            },
            TODAY: {
                name: 'TODAY',
                desc: "Pieni\u0105dze dojd\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego."
            },
            TODAY_OUR: {
                name: 'TODAY OUR',
                desc: "Pieni\u0105dze dojd\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego."
            },
            SEPA: {
                name: 'SEPA',
                desc: "Pieni\u0105dze dojd\u0105 w ci\u0105gu 1 - 2 dni roboczych."
            },
            SEPA_INSTANT: {
                name: 'SEPA INSTANT',
                desc: "Pieni\u0105dze dojd\u0105 w oko\u0142o minut\u0119."
            },
            SPOT: {
                name: 'SPOT',
                desc: "Pieni\u0105dze dojd\u0105 w ci\u0105gu 2 - 3 dni roboczych."
            },
            ELIXIR: {
                name: 'ELIXIR',
                desc: "Pieni\u0105dze dojd\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego."
            },
            LOCAL: {
                name: 'LOCAL',
                desc: "Pieni\u0105dze dojd\u0105 najp\xf3\u017Aniej nast\u0119pnego dnia roboczego."
            }
        }
    },
    timer: {
        update: 'Aktualizacja za:',
        timeUnit: 'sek.'
    },
    countries: {
        AD: 'Andora',
        AE: 'Zjednoczone Emiraty Arabskie',
        AF: 'Afganistan',
        AG: 'Antigua i Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Antyle Holenderskie',
        AO: 'Angola',
        AQ: 'Antarktyka',
        AR: 'Argentyna',
        AS: "Samoa Ameryka\u0144skie",
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AX: 'Wyspy Alandzkie',
        AZ: "Azerbejd\u017Can",
        BA: "Bo\u015Bnia i Hercegowina",
        BB: 'Barbados',
        BD: 'Bangladesz',
        BE: 'Belgia',
        BF: 'Burkina Faso',
        BG: "Bu\u0142garia",
        BH: 'Bahrajn',
        BI: 'Burundi',
        BJ: 'Benin',
        BL: "Saint Barth\xe9lemy",
        BM: 'Bermudy',
        BN: 'Brunei Darussalam',
        BO: 'Boliwia',
        BR: 'Brazylia',
        BS: 'Bahamy',
        BT: 'Bhutan',
        BV: 'Wyspa Bouveta',
        BW: 'Botswana',
        BY: "Bia\u0142oru\u015B",
        BZ: 'Belize',
        CA: 'Kanada',
        CC: 'Wyspy Kokosowe',
        CD: 'Demokratyczna Republika Konga',
        CF: "Republika \u015Arodkowej Afryki",
        CG: 'Kongo',
        CH: 'Szwajcaria',
        CI: "Wybrze\u017Ce Ko\u015Bci S\u0142oniowej",
        CK: 'Wyspy Cooka',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'Chiny',
        CO: 'Kolumbia',
        CR: 'Kostaryka',
        CU: 'Kuba',
        CV: "Wyspy Zielonego Przyl\u0105dka",
        CW: "Cura\xe7ao",
        CX: "Wyspa Bo\u017Cego Narodzenia",
        CY: 'Cypr',
        CZ: 'Czechy',
        DE: 'Niemcy',
        DJ: "D\u017Cibuti",
        DK: 'Dania',
        DM: 'Dominika',
        DO: "Republika Dominika\u0144ska",
        DZ: 'Algieria',
        EC: 'Ekwador',
        EE: 'Estonia',
        EG: 'Egipt',
        EH: 'Sahara Zachodnia',
        ER: 'Erytrea',
        ES: 'Hiszpania',
        ET: 'Etiopia',
        FI: 'Finlandia',
        FJ: "Fid\u017Ci",
        FK: 'Falklandy',
        FM: 'Mikronezja',
        FO: 'Wyspy Owcze',
        FR: 'Francja',
        GA: 'Gabon',
        GB: 'Wielka Brytania',
        GD: 'Grenada',
        GE: 'Gruzja',
        GF: 'Gujana Francuska',
        GG: 'Wyspa Guernsey',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grenlandia',
        GM: 'Gambia',
        GN: 'Gwinea',
        GP: 'Gwadelupa',
        GQ: "Gwinea R\xf3wnikowa",
        GR: 'Grecja',
        GS: "Georgia Po\u0142udniowa i Sandwich Po\u0142udniowy",
        GT: 'Gwatemala',
        GU: 'Guam',
        GW: 'Gwinea Bissau',
        GY: 'Gujana',
        HK: 'Hongkong',
        HM: 'Wyspy Heard i McDonalda',
        HN: 'Honduras',
        HR: 'Chorwacja',
        HT: 'Haiti',
        HU: "W\u0119gry",
        ID: 'Indonezja',
        IE: 'Irlandia',
        IL: 'Izrael',
        IM: 'Wyspa Man',
        IN: 'Indie',
        IO: 'Terytorium Brytyjskie Oceanu Indyjskiego',
        IQ: 'Irak',
        IR: 'Iran',
        IS: 'Islandia',
        IT: "W\u0142ochy",
        JE: 'Wyspa Jersey',
        JM: 'Jamajka',
        JO: 'Jordania',
        JP: 'Japonia',
        KE: 'Kenia',
        KG: 'Kirgistan',
        KH: "Kambod\u017Ca",
        KI: 'Kiribati',
        KM: 'Komory',
        KN: 'Saint Kitts i Nevis',
        KP: "Korea P\xf3\u0142nocna",
        KR: "Korea Po\u0142udniowa",
        KW: 'Kuwejt',
        KY: 'Kajmany',
        KZ: 'Kazachstan',
        LA: 'Laos',
        LB: 'Liban',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litwa',
        LU: 'Luksemburg',
        LV: "\u0141otwa",
        LY: 'Libia',
        MA: 'Maroko',
        MC: 'Monako',
        MD: "Mo\u0142dawia",
        ME: "Czarnog\xf3ra",
        MF: 'Sint Maarten',
        MG: 'Madagaskar',
        MH: 'Wyspy Marshalla',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Birma',
        MN: 'Mongolia',
        MO: 'Makau, Specjalny Region Administracyjny Chin',
        MP: "Mariany P\xf3\u0142nocne",
        MQ: 'Martynika',
        MR: 'Mauretania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Malediwy',
        MW: 'Malawi',
        MX: 'Meksyk',
        MY: 'Malezja',
        MZ: 'Mozambik',
        NA: 'Namibia',
        NC: 'Nowa Kaledonia',
        NE: 'Niger',
        NF: 'Wyspa Norfolk',
        NG: 'Nigeria',
        NI: 'Nikaragua',
        NL: 'Holandia',
        NO: 'Norwegia',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nowa Zelandia',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polinezja Francuska',
        PG: 'Papua Nowa Gwinea',
        PH: 'Filipiny',
        PK: 'Pakistan',
        PL: 'Polska',
        PM: 'Saint-Pierre i Miquelon',
        PN: 'Pitcairn',
        PR: 'Portoryko',
        PS: 'Palestyna',
        PT: 'Portugalia',
        PW: 'Palau',
        PY: 'Paragwaj',
        QA: 'Katar',
        RE: 'Reunion',
        RO: 'Rumunia',
        RS: 'Serbia',
        RU: 'Rosja',
        RW: 'Rwanda',
        SA: 'Arabia Saudyjska',
        SB: 'Wyspy Salomona',
        SC: 'Seszele',
        SD: 'Sudan',
        SE: 'Szwecja',
        SG: 'Singapur',
        SH: "Wyspa \u015Awi\u0119tej Heleny",
        SI: "S\u0142owenia",
        SJ: 'Svalbard i Jan Mayen',
        SK: "S\u0142owacja",
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Surinam',
        ST: "Wyspy \u015Awi\u0119tego Tomasza i Ksi\u0105\u017C\u0119ca",
        SV: 'Salwador',
        SY: 'Syria',
        SZ: 'Suazi',
        TC: 'Turks i Caicos',
        TD: 'Czad',
        TF: "Francuskie Terytoria Po\u0142udniowe",
        TG: 'Togo',
        TH: 'Tajlandia',
        TJ: "Tad\u017Cykistan",
        TK: 'Tokelau',
        TL: 'Timor Wschodni',
        TM: 'Turkmenistan',
        TN: 'Tunezja',
        TO: 'Tonga',
        TR: 'Turcja',
        TT: 'Trynidad i Tobago',
        TV: 'Tuvalu',
        TW: 'Tajwan',
        TZ: 'Tanzania',
        UA: 'Ukraina',
        UG: 'Uganda',
        UM: "Dalekie Wyspy Mniejsze Stan\xf3w Zjednoczonych",
        US: 'Stany Zjednoczone',
        UY: 'Urugwaj',
        UZ: 'Uzbekistan',
        VA: 'Watykan',
        VC: 'Saint Vincent i Grenadyny',
        VE: 'Wenezuela',
        VG: 'Brytyjskie Wyspy Dziewicze',
        VI: "Wyspy Dziewicze Stan\xf3w Zjednoczonych",
        VN: 'Wietnam',
        VU: 'Vanuatu',
        WF: 'Wallis i Futuna',
        WS: 'Samoa',
        XK: 'Kosowo',
        YE: 'Jemen',
        YT: 'Majotta',
        ZA: "Republika Po\u0142udniowej Afryki",
        ZM: 'Zambia',
        ZW: 'Zimbabwe'
    }
};

});

parcelRegister("5xn28", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84253e5151cc10a5$export$2e2bcd8739ae039; });
var $84253e5151cc10a5$export$2e2bcd8739ae039 = {
    calculator: {
        buyLabelName: 'i have',
        swapButtonAriaLabel: 'swap currencies',
        sellLabelName: 'i will receive',
        currentRate: 'Current rate:',
        continueButton: 'Proceed to exchange',
        miniChart: 'The mini-chart shows the fluctuations of the average rate over the last 7 days.',
        sellTooltip: 'This is a sales rate - we sell you {{currency}} for PLN {{rate}}. The lower the rate, the more beneficial it is for you. Automatic update every 10 seconds.',
        buyTooltip: 'This is a buying rate - we buy {{currency}} from you for PLN {{rate}}. The higher the rate, the more beneficial it is for you. Automatic update every 10 seconds.',
        saleNotAvailableInfo: 'Sales in {{baseCurrency}} are currently unavailable',
        minAmount: 'The minimum exchange amount is {{minAmount}} {{minCurrency}}'
    },
    creditCalculator: {
        monthlyLoan: 'Monthly loan instalment',
        loanTerm: 'Loan term remaining',
        whichBank: 'In which bank are you repaying your loan?',
        save: 'Save!',
        years: 'years',
        inYear: 'in a year',
        toEnd: 'by the end of the loan',
        installmentAmount: 'The installment amount is too small'
    },
    profitCalculator: {
        transferNotSupported: "Wybrany bank nie wspiera przelew\xf3w tej waluty.",
        transferFree: "Nie pobieramy \u017Cadnych op\u0142at za wys\u0142anie wymienionych \u015Brodk\xf3w!",
        transferFee: "Za przelew do wybranego przez Ciebie banku jest pobierana op\u0142ata bankowa \u2013 {{transferFee}} PLN. Op\u0142ata zosta\u0142a uwzgl\u0119dniona w wyliczeniu."
    },
    preactSelect: {
        search: 'Search...'
    },
    newsletter: {
        alreadySubscribed: 'Your email is already in our newsletter.',
        error: 'Something went wrong. Try again later.'
    },
    frontpageExitPopup: {
        accountExists: 'It looks like you already have an account. We send a discount to new customers.',
        error: 'An error has occurred'
    },
    emailValidator: {
        requiredField: 'This field must be checked',
        notEmptyField: 'This field cannot be empty',
        minValue: 'The manimum value is',
        maxValue: 'The maximum value is',
        incorrectEmail: 'Please provide valid email address',
        toShortPassword: 'Password is too short'
    },
    currencyAlert: {
        isLower: 'is lower',
        isHigher: 'is higher',
        mustBeLessThan: 'The rate must be a number less than 99.9999',
        alertAlreadyExists: 'A rate alert for the specified rate already exists',
        maxAlerts: 'You cannot subscribe to more alerts. (max. 10)',
        error: 'Something went wrong, please try again in a moment.',
        alertHash: 'currency-alert',
        averageRateNotAvailable: 'Currently, we cannot set an alert because the rate for {{currency}} is temporarily unavailable. ({{averageRate}}).'
    },
    ratesUpdate: {
        update: 'Rates update in progress...',
        success: 'Next update in',
        error: 'Failed to download data. Retry in'
    },
    currencyAnnotations: {
        notSupported: 'Exchange of this currency is currently unavailable'
    },
    landingForm: {
        show: 'Show',
        hide: 'Hide',
        requiredField: 'This field must be checked',
        notEmptyField: 'This field cannot be empty',
        incorrectEmail: 'Please provide valid email address',
        toShortPassword: 'Password is too short',
        invalidPromocode: 'Promotion available on this page has ended - register via the home page',
        emailAlreadyExists: 'This email cannot be used for registration',
        generalInvalid: 'Something went wrong, please try again in a moment',
        competitionFormThanks: 'Thank you for participating in the contest!'
    },
    currencies: {
        AED: 'UAE dirham',
        ARS: 'Argentine peso',
        AUD: 'Australian dollar',
        BDT: 'Bangladeshi taka',
        BGN: 'Bulgarian lev',
        BRL: 'Brazilian real',
        CAD: 'Canadian dollar',
        CHF: 'Swiss franc',
        CLP: 'Chilean peso',
        CNY: 'Chinese yuan',
        COP: 'Colombian peso',
        CZK: 'Czech koruna',
        DKK: 'Danish crown',
        EGP: 'Egyptian Pound',
        EUR: 'Euro',
        FJD: 'Fijian Dollar',
        GBP: 'British pound',
        GHS: 'Ghanaian Cedi',
        HKD: 'Hong Kong dollar',
        HUF: 'Hungarian forint',
        ILS: 'Israeli new shekel',
        INR: 'Indian Rupee',
        JOD: 'Jordanian dinar',
        JPY: 'Japanese yen',
        KWD: 'Kuwaiti Dinar',
        LSL: 'Lesotho loti',
        MAD: 'Moroccan dirham',
        MXN: 'Mexican peso',
        NOK: 'Norwegian krone',
        NPR: 'Nepalese rupee',
        NZD: 'New Zealand dollar',
        OMR: 'Rial Omani',
        PEN: 'Peruvian sol',
        PGK: 'Papua New Guinea Kina',
        PLN: 'Polish zloty',
        RON: 'Romanian leu',
        RUB: 'Russian ruble',
        SAR: 'Saudi riyal',
        SEK: 'Swedish krona',
        SGD: 'Singapore dollar',
        SZL: 'Swazi lilangeni',
        THB: 'Thai baht',
        TRY: 'Turkish lira',
        USD: 'US Dollar',
        UYU: 'Uruguayan peso',
        WST: 'Samoan Tala',
        ZAR: 'South African rand'
    },
    currenciesDopelniacz: {
        AED: 'UAE dirham',
        ARS: 'Argentine peso',
        AUD: 'Australian dollar',
        BDT: 'Bangladeshi taka',
        BGN: 'Bulgarian lev',
        BRL: 'Brazilian real',
        CAD: 'Canadian dollar',
        CHF: 'Swiss franc',
        CLP: 'Chilean peso',
        CNY: 'Chinese yuan',
        COP: 'Colombian peso',
        CZK: 'Czech koruna',
        DKK: 'Danish crown',
        EGP: 'Egyptian Pound',
        EUR: 'Euro',
        FJD: 'Fijian Dollar',
        GBP: 'British pound',
        GHS: 'Ghanaian Cedi',
        HKD: 'Hong Kong dollar',
        HUF: 'Hungarian forint',
        ILS: 'Israeli new shekel',
        INR: 'Indian Rupee',
        JOD: 'Jordanian dinar',
        JPY: 'Japanese yen',
        KWD: 'Kuwaiti Dinar',
        LSL: 'Lesotho loti',
        MAD: 'Moroccan dirham',
        MXN: 'Mexican peso',
        NOK: 'Norwegian krone',
        NPR: 'Nepalese rupee',
        NZD: 'New Zealand dollar',
        OMR: 'Rial Omani',
        PEN: 'Peruvian sol',
        PGK: 'Papua New Guinea Kina',
        PLN: 'Polish zloty',
        RON: 'Romanian leu',
        RUB: 'Russian ruble',
        SAR: 'Saudi riyal',
        SEK: 'Swedish krona',
        SGD: 'Singapore dollar',
        SZL: 'Swazi lilangeni',
        THB: 'Thai baht',
        TRY: 'Turkish lira',
        USD: 'US Dollar',
        UYU: 'Uruguayan peso',
        WST: 'Samoan Tala',
        ZAR: 'South African rand'
    },
    chart: {
        time: 'Time',
        rate: 'Rate',
        opening: 'Opening',
        highest: 'Highest',
        lowest: 'Lowest',
        closing: 'Closing',
        monthNames: [
            'jan',
            'feb',
            'mar',
            'apr',
            'may',
            'jun',
            'jul',
            'aug',
            'sep',
            'oct',
            'nov',
            'dec'
        ],
        dayNames: [
            'mon',
            'tue',
            'wed',
            'thu',
            'fri',
            'sat',
            'sun'
        ]
    },
    networkErrorStatus: {
        slow: 'Problem with downloading exchange rates. Slow internet connection.',
        noNetwork: 'Problem with downloading exchange rates. Check if you have an internet connection.',
        default: 'Technical problems have occurred. Contact customer service.'
    },
    calculatorForegin: {
        continueButton: 'Proceed to exchange',
        exchangeRates: 'Exchange rate',
        details: 'Details',
        amountYouSend: 'The amount you will send',
        countryYouSendMoney: 'The country you will send money to',
        foreignTransferFee: 'Foreign transfer fee',
        foreignTransferType: 'Foreign transfer type',
        exchangeAmount: 'Exchange amount',
        amountRecipientReceive: 'The amount the recipient will receive',
        minAmount: 'The exchange amount is too low.',
        notSellCurrency: 'Currency sales are unavailable.',
        transferTypes: {
            INTERNAL: {
                name: 'INTERNAL',
                desc: 'The money will arrive in about 30 minutes from the moment we receive your transfer, at the latest on the next business day.'
            },
            TODAY: {
                name: 'TODAY',
                desc: 'The money will arrive by the next business day at the latest.'
            },
            TODAY_OUR: {
                name: 'TODAY OUR',
                desc: 'The money will arrive by the next business day at the latest.'
            },
            SEPA: {
                name: 'SEPA',
                desc: 'The money will arrive within 1-2 business days.'
            },
            SEPA_INSTANT: {
                name: 'SEPA INSTANT',
                desc: 'The money will arrive in about a minute.'
            },
            SPOT: {
                name: 'SPOT',
                desc: 'The money will arrive within 2-3 business days.'
            },
            ELIXIR: {
                name: 'ELIXIR',
                desc: 'The money will arrive by the next business day at the latest.'
            },
            LOCAL: {
                name: 'LOCAL',
                desc: 'The money will arrive by the next business day at the latest.'
            }
        }
    },
    timer: {
        update: 'Refreshing in:',
        timeUnit: 'sec.'
    },
    countries: {
        AD: 'Andorra',
        AE: 'United Arab Emirates',
        AF: 'Afghanistan',
        AG: 'Antigua and Barbuda',
        AI: 'Anguilla',
        AL: 'Albania',
        AM: 'Armenia',
        AN: 'Netherlands Antilles',
        AO: 'Angola',
        AQ: 'Antarctica',
        AR: 'Argentina',
        AS: 'American Samoa',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AX: "\xc5land Islands",
        AZ: 'Azerbaijan',
        BA: 'Bosnia and Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Belgium',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BL: "Saint Barth\xe9lemy",
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivia',
        BR: 'Brazil',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet Island',
        BW: 'Botswana',
        BY: 'Belarus',
        BZ: 'Belize',
        CA: 'Canada',
        CC: 'Cocos Islands',
        CD: 'Democratic Republic of the Congo',
        CF: 'Central African Republic',
        CG: 'Congo',
        CH: 'Switzerland',
        CI: 'Ivory Coast',
        CK: 'Cook Islands',
        CL: 'Chile',
        CM: 'Cameroon',
        CN: 'China',
        CO: 'Columbia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cape Verde',
        CW: 'Curacao',
        CX: 'Christmas Island',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DE: 'Germany',
        DJ: 'Djibouti',
        DK: 'Denmark',
        DM: 'Dominica',
        DO: 'Dominican Republic ',
        DZ: 'Algeria',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egypt',
        EH: 'Western Sahara',
        ER: 'Eritrea',
        ES: 'Spain',
        ET: 'Ethiopia',
        FI: 'Finland',
        FJ: 'Fiji',
        FK: 'Falkland Islands',
        FM: 'Micronesia',
        FO: 'Faroe Islands',
        FR: 'France',
        GA: 'Gabon',
        GB: 'Great Britain',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'French Guiana',
        GG: 'Guernsey Island',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Greenland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe',
        GQ: 'Equatorial Guinea',
        GR: 'Greece',
        GS: 'South Georgia and the South Sandwich Islands',
        GT: 'Guatemala',
        GU: 'Guam',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard Island and McDonald Islands',
        HN: 'Honduras',
        HR: 'Croatia',
        HT: 'Haiti',
        HU: 'Hungary',
        ID: 'Indonesia',
        IE: 'Ireland',
        IL: 'Israel',
        IM: 'Isle of Man',
        IN: 'India',
        IO: 'British Indian Ocean Territory',
        IQ: 'Iraq',
        IR: 'Iran',
        IS: 'Iceland',
        IT: 'Italy',
        JE: 'Island of Jersey',
        JM: 'Jamaica',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenya',
        KG: 'Kyrgyzstan',
        KH: 'Cambodia',
        KI: 'Kiribati',
        KM: 'Comoro Islands',
        KN: 'Saint Kitts and Nevis',
        KP: 'North Korea',
        KR: 'South Korea',
        KW: 'Kuwait',
        KY: 'Cayman Islands',
        KZ: 'Kazakhstan',
        LA: 'Laos',
        LB: 'Lebanon',
        LC: 'Saint Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        LV: 'Latvia',
        LY: 'Libya',
        MA: 'Morocco',
        MC: 'Monaco',
        MD: 'Moldova',
        ME: 'Montenegro',
        MF: 'Sint Maarten',
        MG: 'Madagascar',
        MH: 'Marshall Islands',
        MK: 'Macedonia',
        ML: 'Mali',
        MM: 'Burma',
        MN: 'Mongolia',
        MO: "Macao Special Administrative Region of the People's Republic of China",
        MP: 'Northern Mariana Islands',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldives',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malaysia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'New Caledonia',
        NE: 'Niger',
        NF: 'Norfolk Island',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Netherlands',
        NO: 'Norway',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'New Zealand',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'French Polynesia',
        PG: 'Papua New Guinea',
        PH: 'Philippines',
        PK: 'Pakistan',
        PL: 'Poland',
        PM: 'Saint-Pierre and Miquelon',
        PN: 'Pitcairn',
        PR: 'Puerto Rico',
        PS: 'Palestine',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Qatar',
        RE: 'Reunion',
        RO: 'Romania',
        RS: 'Serbia',
        RU: 'Russia',
        RW: 'Rwanda',
        SA: 'Saudi Arabia',
        SB: 'Solomon Islands',
        SC: 'Seychelles',
        SD: 'Sudan',
        SE: 'Sweden',
        SG: 'Singapore',
        SH: 'Saint Helena',
        SI: 'Slovenia',
        SJ: 'Svalbard and Jan Mayen',
        SK: 'Slovakia',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Surinam',
        ST: "S\xe3o Tom\xe9 and Pr\xedncipe",
        SV: 'Salvador',
        SY: 'Syria',
        SZ: 'Suazi',
        TC: 'Turks and Caicos',
        TD: 'Chad',
        TF: 'French Southern and Antarctic Lands',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tajikistan',
        TK: 'Tokelau',
        TL: 'East Timor',
        TM: 'Turkmenistan',
        TN: 'Tunisia',
        TO: 'Tonga',
        TR: 'Turkey',
        TT: 'Trinidad and Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'United States Minor Outlying Islands',
        US: 'United States',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VA: 'Vatican',
        VC: 'Saint Vincent and the Grenadines',
        VE: 'Venezuela',
        VG: 'British Virgin Islands',
        VI: 'United States Virgin Islands',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis and Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'Republic of South Africa',
        ZM: 'Zambia',
        ZW: 'Zimbabwe'
    }
};

});

parcelRegister("2GJ0A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ef42e389357ca79$export$2e2bcd8739ae039; });
var $0ef42e389357ca79$export$2e2bcd8739ae039 = {
    calculator: {
        buyLabelName: "\u0443 \u043C\u0435\u043D\u044F",
        swapButtonAriaLabel: "\u043F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u044B \u043C\u0435\u0441\u0442\u0430\u043C\u0438",
        sellLabelName: "\u043F\u043E\u043B\u0443\u0447\u0443",
        currentRate: "\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u043A\u0443\u0440\u0441:",
        continueButton: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u043E\u0431\u043C\u0435\u043D",
        miniChart: "\u041C\u0438\u043D\u0438-\u0433\u0440\u0430\u0444\u0438\u043A \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442 \u043A\u043E\u043B\u0435\u0431\u0430\u043D\u0438\u044F \u0441\u0440\u0435\u0434\u043D\u0435\u0433\u043E \u043A\u0443\u0440\u0441\u0430 \u0437\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 7 \u0434\u043D\u0435\u0439",
        sellTooltip: "\u042D\u0442\u043E \u043A\u0443\u0440\u0441 \u043F\u0440\u043E\u0434\u0430\u0436\u0438 \u2014 \u043C\u044B \u043F\u0440\u043E\u0434\u0430\u0451\u043C \u0422\u0435\u0431\u0435 {{currency}} \u043F\u043E {{rate}} PLN. \u0427\u0435\u043C \u043D\u0438\u0436\u0435 \u043A\u0443\u0440\u0441, \u0442\u0435\u043C \u0432\u044B\u0433\u043E\u0434\u043D\u0435\u0435 \u0434\u043B\u044F \u0422\u0435\u0431\u044F. \u0410\u0432\u0442\u043E\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u0430\u0436\u0434\u044B\u0435 10 \u0441\u0435\u043A\u0443\u043D\u0434.",
        buyTooltip: "\u042D\u0442\u043E \u043A\u0443\u0440\u0441 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u2014 \u043C\u044B \u043F\u043E\u043A\u0443\u043F\u0430\u0435\u043C \u0443 \u0422\u0435\u0431\u044F {{currency}} \u043F\u043E {{rate}} PLN. \u0427\u0435\u043C \u0432\u044B\u0448\u0435 \u043A\u0443\u0440\u0441, \u0442\u0435\u043C \u0432\u044B\u0433\u043E\u0434\u043D\u0435\u0435 \u0434\u043B\u044F \u0422\u0435\u0431\u044F. \u0410\u0432\u0442\u043E\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u0430\u0436\u0434\u044B\u0435 10 \u0441\u0435\u043A\u0443\u043D\u0434.",
        saleNotAvailableInfo: "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043F\u0440\u043E\u0434\u0430\u0436\u0430 {{baseCurrency}} \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430",
        minAmount: "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u043E\u0431\u043C\u0435\u043D\u0430 \u2014 {{minAmount}} {{minCurrency}}."
    },
    creditCalculator: {
        monthlyLoan: "\u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0439 \u043F\u043B\u0430\u0442\u0451\u0436 \u043F\u043E \u043A\u0440\u0435\u0434\u0438\u0442\u0443",
        loanTerm: "\u0414\u043E \u043A\u043E\u043D\u0446\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430 \u043E\u0441\u0442\u0430\u043B\u043E\u0441\u044C",
        whichBank: "\u0412 \u043A\u0430\u043A\u043E\u043C \u0431\u0430\u043D\u043A\u0435 \u0422\u044B \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0448\u044C \u043A\u0440\u0435\u0434\u0438\u0442?",
        save: "\u042D\u043A\u043E\u043D\u043E\u043C\u044C!",
        years: "\u043B\u0435\u0442",
        inYear: "\u0437\u0430 \u0433\u043E\u0434",
        toEnd: "\u0434\u043E \u043A\u043E\u043D\u0446\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
        installmentAmount: "\u0421\u0443\u043C\u043C\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u043C\u0430\u043B\u0430"
    },
    transferTypes: {
        INTERNAL: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u043E \u0447\u0435\u0440\u0435\u0437 30 \u043C\u0438\u043D\u0443\u0442 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0422\u0432\u043E\u0435\u0433\u043E \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0430, \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0434\u043D\u044F.",
        TODAY: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0434\u043D\u044F.",
        TODAY_OUR: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0434\u043D\u044F.",
        SEPA: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0438 1 - 2 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439.",
        SEPA_INSTANT: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u043E \u0437\u0430 1 \u043C\u0438\u043D\u0443\u0442\u0443.",
        SPOT: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0438 2 - 3 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439.",
        ELIXIR: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0434\u043D\u044F.",
        LOCAL: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0434\u043D\u044F."
    },
    profitCalculator: {
        transferNotSupported: "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0431\u0430\u043D\u043A \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u044B \u044D\u0442\u043E\u0439 \u0432\u0430\u043B\u044E\u0442\u044B.",
        transferFree: "\u041C\u044B \u043D\u0435 \u0432\u0437\u0438\u043C\u0430\u0435\u043C \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439 \u0437\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0443 \u043E\u0431\u043C\u0435\u043D\u0435\u043D\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432!",
        transferFee: "\u0417\u0430 \u043F\u0435\u0440\u0435\u0432\u043E\u0434 \u0432 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0422\u043E\u0431\u043E\u0439 \u0431\u0430\u043D\u043A \u0432\u0437\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u2013 {{transferFee}} PLN. \u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u0443\u0436\u0435 \u0443\u0447\u0442\u0435\u043D\u0430 \u0432 \u0440\u0430\u0441\u0447\u0451\u0442\u0435."
    },
    preactSelect: {
        search: "\u041F\u043E\u0438\u0441\u043A..."
    },
    newsletter: {
        alreadySubscribed: "\u0422\u0432\u043E\u0439 e-mail \u0443\u0436\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D \u043D\u0430 \u043D\u0430\u0448\u0443 \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0443.",
        error: "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439 \u043F\u043E\u0437\u0436\u0435."
    },
    frontpageExitPopup: {
        accountExists: "\u041F\u043E\u0445\u043E\u0436\u0435, \u0443 \u0422\u0435\u0431\u044F \u0443\u0436\u0435 \u0435\u0441\u0442\u044C \u0443\u0447\u0451\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C. \u0421\u043A\u0438\u0434\u043A\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043D\u043E\u0432\u044B\u0445 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432.",
        error: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430"
    },
    emailValidator: {
        requiredField: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043E\u0442\u043C\u0435\u0442\u0438\u0442\u044C \u044D\u0442\u043E \u043F\u043E\u043B\u0435",
        notEmptyField: "\u042D\u0442\u043E \u043F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C",
        minValue: "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435  \u2013",
        maxValue: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u2013",
        incorrectEmail: "\u0412\u0432\u0435\u0434\u0438 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
        toShortPassword: "\u041F\u0430\u0440\u043E\u043B\u044C \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439"
    },
    currencyAlert: {
        isLower: "\u0431\u0443\u0434\u0435\u0442 \u043D\u0438\u0436\u0435",
        isHigher: "\u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u0448\u0435",
        mustBeLessThan: "\u041A\u0443\u0440\u0441 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0447\u0438\u0441\u043B\u043E\u043C \u043C\u0435\u043D\u044C\u0448\u0435 99,9999",
        alertAlreadyExists: "\u041E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043A\u0443\u0440\u0441\u0430 \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442",
        maxAlerts: "\u0422\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0448\u044C \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u0431\u043E\u043B\u044C\u0448\u0435\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0439 (\u043C\u0430\u043A\u0441. 10)",
        error: "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439 \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443.",
        alertHash: "\u0432\u0430\u043B\u044E\u0442\u043D\u043E\u0435-\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435",
        averageRateNotAvailable: "\u0421\u0435\u0439\u0447\u0430\u0441 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435, \u0442\u0430\u043A \u043A\u0430\u043A \u043A\u0443\u0440\u0441 {{currency}} \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D ({{averageRate}})."
    },
    ratesUpdate: {
        update: "\u0418\u0434\u0451\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u0443\u0440\u0441\u043E\u0432...",
        success: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u0443\u0440\u0441\u0430 \u0447\u0435\u0440\u0435\u0437",
        error: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435. \u041F\u043E\u0432\u0442\u043E\u0440 \u0447\u0435\u0440\u0435\u0437"
    },
    currencyAnnotations: {
        notSupported: "\u041E\u0431\u043C\u0435\u043D \u044D\u0442\u043E\u0439 \u0432\u0430\u043B\u044E\u0442\u044B \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D"
    },
    currencies: {
        AED: "\u0414\u0438\u0440\u0445\u0430\u043C \u041E\u0410\u042D",
        ARS: "\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0441\u043A\u043E\u0435 \u043F\u0435\u0441\u043E",
        AUD: "\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0438\u0439\u0441\u043A\u0438\u0439 \u0434\u043E\u043B\u043B\u0430\u0440",
        BDT: "\u0411\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448\u0441\u043A\u0430\u044F \u0442\u0430\u043A\u0430",
        BGN: "\u0411\u043E\u043B\u0433\u0430\u0440\u0441\u043A\u0438\u0439 \u043B\u0435\u0432",
        BRL: "\u0411\u0440\u0430\u0437\u0438\u043B\u044C\u0441\u043A\u0438\u0439 \u0440\u0435\u0430\u043B",
        CAD: "\u041A\u0430\u043D\u0430\u0434\u0441\u043A\u0438\u0439 \u0434\u043E\u043B\u043B\u0430\u0440",
        CHF: "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0441\u043A\u0438\u0439 \u0444\u0440\u0430\u043D\u043A",
        CLP: "\u0427\u0438\u043B\u0438\u0439\u0441\u043A\u043E\u0435 \u043F\u0435\u0441\u043E",
        CNY: "\u041A\u0438\u0442\u0430\u0439\u0441\u043A\u0438\u0439 \u044E\u0430\u043D\u044C",
        COP: "\u041A\u043E\u043B\u0443\u043C\u0431\u0438\u0439\u0441\u043A\u043E\u0435 \u043F\u0435\u0441\u043E",
        CZK: "\u0427\u0435\u0448\u0441\u043A\u0430\u044F \u043A\u0440\u043E\u043D\u0430",
        DKK: "\u0414\u0430\u0442\u0441\u043A\u0430\u044F \u043A\u0440\u043E\u043D\u0430",
        EGP: "\u0415\u0433\u0438\u043F\u0435\u0442\u0441\u043A\u0438\u0439 \u0444\u0443\u043D\u0442",
        EUR: "\u0415\u0432\u0440\u043E",
        FJD: "\u0414\u043E\u043B\u043B\u0430\u0440 \u0424\u0438\u0434\u0436\u0438",
        GBP: "\u0424\u0443\u043D\u0442 \u0441\u0442\u0435\u0440\u043B\u0438\u043D\u0433\u043E\u0432",
        GHS: "\u0413\u0430\u043D\u0441\u043A\u0438\u0439 \u0441\u0435\u0434\u0438",
        HKD: "\u0413\u043E\u043D\u043A\u043E\u043D\u0433\u0441\u043A\u0438\u0439 \u0434\u043E\u043B\u043B\u0430\u0440",
        HUF: "\u0412\u0435\u043D\u0433\u0435\u0440\u0441\u043A\u0438\u0439 \u0444\u043E\u0440\u0438\u043D\u0442",
        ILS: "\u0418\u0437\u0440\u0430\u0438\u043B\u044C\u0441\u043A\u0438\u0439 \u043D\u043E\u0432\u044B\u0439 \u0448\u0435\u043A\u0435\u043B\u044C",
        INR: "\u0418\u043D\u0434\u0438\u0439\u0441\u043A\u0430\u044F \u0440\u0443\u043F\u0438\u044F",
        JOD: "\u0418\u043E\u0440\u0434\u0430\u043D\u0441\u043A\u0438\u0439 \u0434\u0438\u043D\u0430\u0440",
        JPY: "\u042F\u043F\u043E\u043D\u0441\u043A\u0430\u044F \u0438\u0435\u043D\u0430",
        KWD: "\u041A\u0443\u0432\u0435\u0439\u0442\u0441\u043A\u0438\u0439 \u0434\u0438\u043D\u0430\u0440",
        LSL: "\u041B\u043E\u0442\u0438 \u041B\u0435\u0441\u043E\u0442\u043E",
        MXN: "\u041C\u0435\u043A\u0441\u0438\u043A\u0430\u043D\u0441\u043A\u043E\u0435 \u043F\u0435\u0441\u043E",
        NOK: "\u041D\u043E\u0440\u0432\u0435\u0436\u0441\u043A\u0430\u044F \u043A\u0440\u043E\u043D\u0430",
        NPR: "\u041D\u0435\u043F\u0430\u043B\u044C\u0441\u043A\u0430\u044F \u0440\u0443\u043F\u0438\u044F",
        NZD: "\u041D\u043E\u0432\u043E\u0437\u0435\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0439 \u0434\u043E\u043B\u043B\u0430\u0440",
        OMR: "\u041E\u043C\u0430\u043D\u0441\u043A\u0438\u0439 \u0440\u0438\u0430\u043B",
        PEN: "\u041F\u0435\u0440\u0443\u0430\u043D\u0441\u043A\u0438\u0439 \u0441\u043E\u043B\u044C",
        PGK: "\u041A\u0438\u043D\u0430 \u041F\u0430\u043F\u0443\u0430 \u2014 \u041D\u043E\u0432\u043E\u0439 \u0413\u0432\u0438\u043D\u0435\u0438",
        PLN: "\u041F\u043E\u043B\u044C\u0441\u043A\u0438\u0439 \u0437\u043B\u043E\u0442\u044B\u0439",
        RON: "\u0420\u0443\u043C\u044B\u043D\u0441\u043A\u0438\u0439 \u043B\u0435\u0439",
        RUB: "\u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0438\u0439 \u0440\u0443\u0431\u043B\u044C",
        SAR: "\u0421\u0430\u0443\u0434\u043E\u0432\u0441\u043A\u0438\u0439 \u0440\u0438\u044F\u043B",
        SEK: "\u0428\u0432\u0435\u0434\u0441\u043A\u0430\u044F \u043A\u0440\u043E\u043D\u0430",
        SGD: "\u0421\u0438\u043D\u0433\u0430\u043F\u0443\u0440\u0441\u043A\u0438\u0439 \u0434\u043E\u043B\u043B\u0430\u0440",
        SZL: "\u0421\u0432\u0430\u0437\u0438\u043B\u0435\u043D\u0434\u0441\u043A\u0438\u0439 \u043B\u0438\u043B\u0430\u043D\u0433\u0435\u043D\u0438",
        THB: "\u0422\u0430\u0439\u0441\u043A\u0438\u0439 \u0431\u0430\u0442",
        TRY: "\u0422\u0443\u0440\u0435\u0446\u043A\u0430\u044F \u043B\u0438\u0440\u0430",
        USD: "\u0414\u043E\u043B\u043B\u0430\u0440 \u0421\u0428\u0410",
        UYU: "\u0423\u0440\u0443\u0433\u0432\u0430\u0439\u0441\u043A\u043E\u0435 \u043F\u0435\u0441\u043E",
        WST: "\u0421\u0430\u043C\u043E\u0430\u043D\u0441\u043A\u0430\u044F \u0442\u0430\u043B\u0430",
        ZAR: "\u042E\u0436\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0438\u0439 \u0440\u0430\u043D\u0434"
    },
    currenciesDopelniacz: {
        AED: "\u0434\u0438\u0440\u0445\u0430\u043C\u0430 \u041E\u0410\u042D",
        ARS: "\u0430\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0441\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
        AUD: "\u0430\u0432\u0441\u0442\u0440\u0430\u043B\u0438\u0439\u0441\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u043B\u0430\u0440\u0430",
        BDT: "\u0431\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448\u0441\u043A\u043E\u0439 \u0442\u0430\u043A\u0438",
        BGN: "\u0431\u043E\u043B\u0433\u0430\u0440\u0441\u043A\u043E\u0433\u043E \u043B\u0435\u0432\u0430",
        BRL: "\u0431\u0440\u0430\u0437\u0438\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0440\u0435\u0430\u043B\u0430",
        CAD: "\u043A\u0430\u043D\u0430\u0434\u0441\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u043B\u0430\u0440\u0430",
        CHF: "\u0448\u0432\u0435\u0439\u0446\u0430\u0440\u0441\u043A\u043E\u0433\u043E \u0444\u0440\u0430\u043D\u043A\u0430",
        CNY: "\u043A\u0438\u0442\u0430\u0439\u0441\u043A\u043E\u0433\u043E \u044E\u0430\u043D\u044F",
        CZK: "\u0447\u0435\u0448\u0441\u043A\u043E\u0439 \u043A\u0440\u043E\u043D\u044B",
        DKK: "\u0434\u0430\u0442\u0441\u043A\u043E\u0439 \u043A\u0440\u043E\u043D\u044B",
        EGP: "\u0435\u0433\u0438\u043F\u0435\u0442\u0441\u043A\u043E\u0433\u043E \u0444\u0443\u043D\u0442\u0430",
        EUR: "\u0435\u0432\u0440\u043E",
        FJD: "\u0434\u043E\u043B\u043B\u0430\u0440\u0430 \u0424\u0438\u0434\u0436\u0438",
        GBP: "\u0444\u0443\u043D\u0442\u0430 \u0441\u0442\u0435\u0440\u043B\u0438\u043D\u0433\u043E\u0432",
        GHS: "\u0433\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u0441\u0435\u0434\u0438",
        HKD: "\u0433\u043E\u043D\u043A\u043E\u043D\u0433\u0441\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u043B\u0430\u0440\u0430",
        INR: "\u0438\u043D\u0434\u0438\u0439\u0441\u043A\u043E\u0439 \u0440\u0443\u043F\u0438\u0438",
        JOD: "\u0438\u043E\u0440\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u0434\u0438\u043D\u0430\u0440\u0430",
        KWD: "\u043A\u0443\u0432\u0435\u0439\u0442\u0441\u043A\u043E\u0433\u043E \u0434\u0438\u043D\u0430\u0440\u0430",
        LSL: "\u043B\u043E\u0442\u0438 \u041B\u0435\u0441\u043E\u0442\u043E",
        MXN: "\u043C\u0435\u043A\u0441\u0438\u043A\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
        NOK: "\u043D\u043E\u0440\u0432\u0435\u0436\u0441\u043A\u043E\u0439 \u043A\u0440\u043E\u043D\u044B",
        NPR: "\u043D\u0435\u043F\u0430\u043B\u044C\u0441\u043A\u043E\u0439 \u0440\u0443\u043F\u0438\u0438",
        NZD: "\u043D\u043E\u0432\u043E\u0437\u0435\u043B\u0430\u043D\u0434\u0441\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u043B\u0430\u0440\u0430",
        OMR: "\u043E\u043C\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u0440\u0438\u0430\u043B\u0430",
        PEN: "\u043F\u0435\u0440\u0443\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u0441\u043E\u043B\u044F",
        PGK: "\u043A\u0438\u043D\u044B \u041F\u0430\u043F\u0443\u0430 - \u041D\u043E\u0432\u043E\u0439 \u0413\u0432\u0438\u043D\u0435\u0438",
        PLN: "\u043F\u043E\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0437\u043B\u043E\u0442\u043E\u0433\u043E",
        RON: "\u0440\u0443\u043C\u044B\u043D\u0441\u043A\u043E\u0433\u043E \u043B\u0435\u044F",
        RUB: "\u0440\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0433\u043E \u0440\u0443\u0431\u043B\u044F",
        SAR: "\u0441\u0430\u0443\u0434\u043E\u0432\u0441\u043A\u043E\u0433\u043E \u0440\u0438\u044F\u043B\u0430",
        SEK: "\u0448\u0432\u0435\u0434\u0441\u043A\u043E\u0439 \u043A\u0440\u043E\u043D\u044B",
        SGD: "\u0441\u0438\u043D\u0433\u0430\u043F\u0443\u0440\u0441\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u043B\u0430\u0440\u0430",
        SZL: "\u0441\u0432\u0430\u0437\u0438\u043B\u0435\u043D\u0434\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u043B\u0430\u043D\u0433\u0435\u043D\u0438",
        THB: "\u0442\u0430\u0439\u0441\u043A\u043E\u0433\u043E \u0431\u0430\u0442\u0430",
        TRY: "\u0442\u0443\u0440\u0435\u0446\u043A\u043E\u0439 \u043B\u0438\u0440\u044B",
        USD: "\u0434\u043E\u043B\u043B\u0430\u0440\u0430 \u0421\u0428\u0410",
        UYU: "\u0443\u0440\u0443\u0433\u0432\u0430\u0439\u0441\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
        WST: "\u0441\u0430\u043C\u043E\u0430\u043D\u0441\u043A\u043E\u0439 \u0442\u0430\u043B\u044B",
        ZAR: "\u044E\u0436\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u0440\u0430\u043D\u0434\u0430"
    },
    chart: {
        time: "\u0412\u0440\u0435\u043C\u044F",
        rate: "\u041A\u0443\u0440\u0441",
        opening: "\u041E\u0442\u043A\u0440\u044B\u0442\u0438\u0435",
        highest: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439",
        lowest: "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439",
        closing: "\u0417\u0430\u043A\u0440\u044B\u0442\u0438\u0435",
        monthNames: [
            "\u044F\u043D\u0432",
            "\u0444\u0435\u0432",
            "\u043C\u0430\u0440",
            "\u0430\u043F\u0440",
            "\u043C\u0430\u0439",
            "\u0438\u044E\u043D",
            "\u0438\u044E\u043B",
            "\u0430\u0432\u0433",
            "\u0441\u0435\u043D",
            "\u043E\u043A\u0442",
            "\u043D\u043E\u044F",
            "\u0434\u0435\u043A"
        ],
        dayNames: [
            "\u043F\u043D",
            "\u0432\u0442",
            "\u0441\u0440",
            "\u0447\u0442",
            "\u043F\u0442",
            "\u0441\u0431",
            "\u0432\u0441"
        ]
    },
    landingForm: {
        show: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C",
        hide: "\u0421\u043A\u0440\u044B\u0442\u044C",
        requiredField: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043E\u0442\u043C\u0435\u0442\u0438\u0442\u044C \u044D\u0442\u043E \u043F\u043E\u043B\u0435",
        notEmptyField: "\u042D\u0442\u043E \u043F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C",
        incorrectEmail: "\u0412\u0432\u0435\u0434\u0438 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
        toShortPassword: "\u041F\u0430\u0440\u043E\u043B\u044C \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439",
        invalidPromocode: "\u0410\u043A\u0446\u0438\u044F \u043D\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0443\u0436\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u043B\u0430\u0441\u044C - \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0441\u044F \u0447\u0435\u0440\u0435\u0437 \u0433\u043B\u0430\u0432\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
        emailAlreadyExists: "\u042D\u0442\u043E\u0442 e-mail \u043D\u0435\u043B\u044C\u0437\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0434\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438",
        generalInvalid: "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439 \u043F\u043E\u0437\u0436\u0435",
        competitionFormThanks: "\u0421\u043F\u0430\u0441\u0438\u0431\u043E \u0437\u0430 \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u043A\u043E\u043D\u043A\u0443\u0440\u0441\u0435!"
    },
    networkErrorStatus: {
        slow: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0441 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u043E\u0439 \u043A\u0443\u0440\u0441\u043E\u0432 \u0432\u0430\u043B\u044E\u0442. \u041C\u0435\u0434\u043B\u0435\u043D\u043D\u043E\u0435 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435.",
        noNetwork: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0441 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u043E\u0439 \u043A\u0443\u0440\u0441\u043E\u0432 \u0432\u0430\u043B\u044E\u0442. \u041F\u0440\u043E\u0432\u0435\u0440\u044C \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443.",
        default: "\u0412\u043E\u0437\u043D\u0438\u043A\u043B\u0438 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B. \u041E\u0431\u0440\u0430\u0442\u0438\u0441\u044C \u0432 \u041E\u0442\u0434\u0435\u043B \u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F \u041A\u043B\u0438\u0435\u043D\u0442\u0430."
    },
    calculatorForegin: {
        continueButton: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u043E\u0431\u043C\u0435\u043D",
        exchangeRates: "\u041A\u0443\u0440\u0441 \u043E\u0431\u043C\u0435\u043D\u0430",
        details: "\u0414\u0435\u0442\u0430\u043B\u0438",
        amountYouSend: "\u0421\u0443\u043C\u043C\u0430, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u0432\u043D\u043E\u0448\u0443",
        countryYouSendMoney: "\u0421\u0442\u0440\u0430\u043D\u0430, \u0432 \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u0422\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0448\u044C \u0434\u0435\u043D\u044C\u0433\u0438",
        foreignTransferFee: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u0437\u0430 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u043F\u0435\u0440\u0435\u0432\u043E\u0434",
        foreignTransferType: "\u0422\u0438\u043F \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0430",
        exchangeAmount: "\u0421\u0443\u043C\u043C\u0430 \u043E\u0431\u043C\u0435\u043D\u0430",
        amountRecipientReceive: "\u0421\u0443\u043C\u043C\u0430, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C",
        minAmount: "\u0421\u0443\u043C\u043C\u0430 \u043E\u0431\u043C\u0435\u043D\u0430 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u043C\u0430\u043B\u0430.",
        notSellCurrency: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0432\u0430\u043B\u044E\u0442\u044B \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430.",
        transferTypes: {
            INTERNAL: {
                name: 'INTERNAL',
                desc: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u043E \u0447\u0435\u0440\u0435\u0437 30 \u043C\u0438\u043D\u0443\u0442 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0422\u0432\u043E\u0435\u0433\u043E \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0430, \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0434\u043D\u044F."
            },
            TODAY: {
                name: 'TODAY',
                desc: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0434\u043D\u044F."
            },
            TODAY_OUR: {
                name: 'TODAY OUR',
                desc: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0434\u043D\u044F."
            },
            SEPA: {
                name: 'SEPA',
                desc: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0438 1 - 2 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439."
            },
            SEPA_INSTANT: {
                name: 'SEPA INSTANT',
                desc: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u043E \u0437\u0430 1 \u043C\u0438\u043D\u0443\u0442\u0443."
            },
            SPOT: {
                name: 'SPOT',
                desc: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0438 2 - 3 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0435\u0439."
            },
            ELIXIR: {
                name: 'ELIXIR',
                desc: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0434\u043D\u044F."
            },
            LOCAL: {
                name: 'LOCAL',
                desc: "\u0414\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E \u0434\u043D\u044F."
            }
        }
    },
    timer: {
        update: "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0447\u0435\u0440\u0435\u0437:",
        timeUnit: "\u0441\u0435\u043A."
    },
    countries: {
        AD: "\u0410\u043D\u0434\u043E\u0440\u0440\u0430",
        AE: "\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0451\u043D\u043D\u044B\u0435 \u0410\u0440\u0430\u0431\u0441\u043A\u0438\u0435 \u042D\u043C\u0438\u0440\u0430\u0442\u044B",
        AF: "\u0410\u0444\u0433\u0430\u043D\u0438\u0441\u0442\u0430\u043D",
        AG: "\u0410\u043D\u0442\u0438\u0433\u0443\u0430 \u0438 \u0411\u0430\u0440\u0431\u0443\u0434\u0430",
        AI: "\u0410\u043D\u0433\u0438\u043B\u044C\u044F",
        AL: "\u0410\u043B\u0431\u0430\u043D\u0438\u044F",
        AM: "\u0410\u0440\u043C\u0435\u043D\u0438\u044F",
        AN: "\u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0435 \u0410\u043D\u0442\u0438\u043B\u044C\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        AO: "\u0410\u043D\u0433\u043E\u043B\u0430",
        AQ: "\u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0434\u0430",
        AR: "\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0430",
        AS: "\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u043E\u0435 \u0421\u0430\u043C\u043E\u0430",
        AT: "\u0410\u0432\u0441\u0442\u0440\u0438\u044F",
        AU: "\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0438\u044F",
        AW: "\u0410\u0440\u0443\u0431\u0430",
        AX: "\u0410\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        AZ: "\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D",
        BA: "\u0411\u043E\u0441\u043D\u0438\u044F \u0438 \u0413\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430",
        BB: "\u0411\u0430\u0440\u0431\u0430\u0434\u043E\u0441",
        BD: "\u0411\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448",
        BE: "\u0411\u0435\u043B\u044C\u0433\u0438\u044F",
        BF: "\u0411\u0443\u0440\u043A\u0438\u043D\u0430-\u0424\u0430\u0441\u043E",
        BG: "\u0411\u043E\u043B\u0433\u0430\u0440\u0438\u044F",
        BH: "\u0411\u0430\u0445\u0440\u0435\u0439\u043D",
        BI: "\u0411\u0443\u0440\u0443\u043D\u0434\u0438",
        BJ: "\u0411\u0435\u043D\u0438\u043D",
        BL: "\u0421\u0435\u043D-\u0411\u0430\u0440\u0442\u0435\u043B\u0435\u043C\u0438",
        BM: "\u0411\u0435\u0440\u043C\u0443\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        BN: "\u0411\u0440\u0443\u043D\u0435\u0439",
        BO: "\u0411\u043E\u043B\u0438\u0432\u0438\u044F",
        BR: "\u0411\u0440\u0430\u0437\u0438\u043B\u0438\u044F",
        BS: "\u0411\u0430\u0433\u0430\u043C\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        BT: "\u0411\u0443\u0442\u0430\u043D",
        BV: "\u041E\u0441\u0442\u0440\u043E\u0432 \u0411\u0443\u0432\u0435",
        BW: "\u0411\u043E\u0442\u0441\u0432\u0430\u043D\u0430",
        BY: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
        BZ: "\u0411\u0435\u043B\u0438\u0437",
        CA: "\u041A\u0430\u043D\u0430\u0434\u0430",
        CC: "\u041A\u043E\u043A\u043E\u0441\u043E\u0432\u044B\u0435 (\u041A\u0438\u043B\u0438\u043D\u0433) \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        CD: "\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043D\u0433\u043E",
        CF: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
        CG: "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043D\u0433\u043E",
        CH: "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0438\u044F",
        CI: "\u041A\u043E\u0442-\u0434'\u0418\u0432\u0443\u0430\u0440",
        CK: "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u041A\u0443\u043A\u0430",
        CL: "\u0427\u0438\u043B\u0438",
        CM: "\u041A\u0430\u043C\u0435\u0440\u0443\u043D",
        CN: "\u041A\u0438\u0442\u0430\u0439",
        CO: "\u041A\u043E\u043B\u0443\u043C\u0431\u0438\u044F",
        CR: "\u041A\u043E\u0441\u0442\u0430-\u0420\u0438\u043A\u0430",
        CU: "\u041A\u0443\u0431\u0430",
        CV: "\u041A\u0430\u0431\u043E-\u0412\u0435\u0440\u0434\u0435",
        CW: "\u041A\u044E\u0440\u0430\u0441\u0430\u043E",
        CX: "\u041E\u0441\u0442\u0440\u043E\u0432 \u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0430",
        CY: "\u041A\u0438\u043F\u0440",
        CZ: "\u0427\u0435\u0445\u0438\u044F",
        DE: "\u0413\u0435\u0440\u043C\u0430\u043D\u0438\u044F",
        DJ: "\u0414\u0436\u0438\u0431\u0443\u0442\u0438",
        DK: "\u0414\u0430\u043D\u0438\u044F",
        DM: "\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430",
        DO: "\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
        DZ: "\u0410\u043B\u0436\u0438\u0440",
        EC: "\u042D\u043A\u0432\u0430\u0434\u043E\u0440",
        EE: "\u042D\u0441\u0442\u043E\u043D\u0438\u044F",
        EG: "\u0415\u0433\u0438\u043F\u0435\u0442",
        EH: "\u0417\u0430\u043F\u0430\u0434\u043D\u0430\u044F \u0421\u0430\u0445\u0430\u0440\u0430",
        ER: "\u042D\u0440\u0438\u0442\u0440\u0435\u044F",
        ES: "\u0418\u0441\u043F\u0430\u043D\u0438\u044F",
        ET: "\u042D\u0444\u0438\u043E\u043F\u0438\u044F",
        FI: "\u0424\u0438\u043D\u043B\u044F\u043D\u0434\u0438\u044F",
        FJ: "\u0424\u0438\u0434\u0436\u0438",
        FK: "\u0424\u043E\u043B\u043A\u043B\u0435\u043D\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        FM: "\u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u0428\u0442\u0430\u0442\u044B \u041C\u0438\u043A\u0440\u043E\u043D\u0435\u0437\u0438\u0438",
        FO: "\u0424\u0430\u0440\u0435\u0440\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        FR: "\u0424\u0440\u0430\u043D\u0446\u0438\u044F",
        GA: "\u0413\u0430\u0431\u043E\u043D",
        GB: "\u0412\u0435\u043B\u0438\u043A\u043E\u0431\u0440\u0438\u0442\u0430\u043D\u0438\u044F",
        GD: "\u0413\u0440\u0435\u043D\u0430\u0434\u0430",
        GE: "\u0413\u0440\u0443\u0437\u0438\u044F",
        GF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u0413\u0432\u0438\u0430\u043D\u0430",
        GG: "\u0413\u0435\u0440\u043D\u0441\u0438",
        GH: "\u0413\u0430\u043D\u0430",
        GI: "\u0413\u0438\u0431\u0440\u0430\u043B\u0442\u0430\u0440",
        GL: "\u0413\u0440\u0435\u043D\u043B\u0430\u043D\u0434\u0438\u044F",
        GM: "\u0413\u0430\u043C\u0431\u0438\u044F",
        GN: "\u0413\u0432\u0438\u043D\u0435\u044F",
        GP: "\u0413\u0432\u0430\u0434\u0435\u043B\u0443\u043F\u0430",
        GQ: "\u042D\u043A\u0432\u0430\u0442\u043E\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F",
        GR: "\u0413\u0440\u0435\u0446\u0438\u044F",
        GS: "\u042E\u0436\u043D\u0430\u044F \u0413\u0435\u043E\u0440\u0433\u0438\u044F \u0438 \u042E\u0436\u043D\u044B\u0435 \u0421\u0430\u043D\u0434\u0432\u0438\u0447\u0435\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        GT: "\u0413\u0432\u0430\u0442\u0435\u043C\u0430\u043B\u0430",
        GU: "\u0413\u0443\u0430\u043C",
        GW: "\u0413\u0432\u0438\u043D\u0435\u044F-\u0411\u0438\u0441\u0430\u0443",
        GY: "\u0413\u0430\u0439\u0430\u043D\u0430",
        HK: "\u0413\u043E\u043D\u043A\u043E\u043D\u0433",
        HM: "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u0425\u0435\u0440\u0434 \u0438 \u041C\u0430\u043A\u0434\u043E\u043D\u0430\u043B\u044C\u0434",
        HN: "\u0413\u043E\u043D\u0434\u0443\u0440\u0430\u0441",
        HR: "\u0425\u043E\u0440\u0432\u0430\u0442\u0438\u044F",
        HT: "\u0413\u0430\u0438\u0442\u0438",
        HU: "\u0412\u0435\u043D\u0433\u0440\u0438\u044F",
        ID: "\u0418\u043D\u0434\u043E\u043D\u0435\u0437\u0438\u044F",
        IE: "\u0418\u0440\u043B\u0430\u043D\u0434\u0438\u044F",
        IL: "\u0418\u0437\u0440\u0430\u0438\u043B\u044C",
        IM: "\u041E\u0441\u0442\u0440\u043E\u0432 \u041C\u044D\u043D",
        IN: "\u0418\u043D\u0434\u0438\u044F",
        IO: "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0430\u044F \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u0432 \u0418\u043D\u0434\u0438\u0439\u0441\u043A\u043E\u043C \u043E\u043A\u0435\u0430\u043D\u0435",
        IQ: "\u0418\u0440\u0430\u043A",
        IR: "\u0418\u0440\u0430\u043D",
        IS: "\u0418\u0441\u043B\u0430\u043D\u0434\u0438\u044F",
        IT: "\u0418\u0442\u0430\u043B\u0438\u044F",
        JE: "\u0414\u0436\u0435\u0440\u0441\u0438",
        JM: "\u042F\u043C\u0430\u0439\u043A\u0430",
        JO: "\u0418\u043E\u0440\u0434\u0430\u043D\u0438\u044F",
        JP: "\u042F\u043F\u043E\u043D\u0438\u044F",
        KE: "\u041A\u0435\u043D\u0438\u044F",
        KG: "\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F",
        KH: "\u041A\u0430\u043C\u0431\u043E\u0434\u0436\u0430",
        KI: "\u041A\u0438\u0440\u0438\u0431\u0430\u0442\u0438",
        KM: "\u041A\u043E\u043C\u043E\u0440\u044B",
        KN: "\u0421\u0435\u043D\u0442-\u041A\u0438\u0442\u0441 \u0438 \u041D\u0435\u0432\u0438\u0441",
        KP: "\u041A\u041D\u0414\u0420",
        KR: "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0440\u0435\u044F",
        KW: "\u041A\u0443\u0432\u0435\u0439\u0442",
        KY: "\u041A\u0430\u0439\u043C\u0430\u043D\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        KZ: "\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D",
        LA: "\u041B\u0430\u043E\u0441",
        LB: "\u041B\u0438\u0432\u0430\u043D",
        LC: "\u0421\u0435\u043D\u0442-\u041B\u044E\u0441\u0438\u044F",
        LI: "\u041B\u0438\u0445\u0442\u0435\u043D\u0448\u0442\u0435\u0439\u043D",
        LK: "\u0428\u0440\u0438-\u041B\u0430\u043D\u043A\u0430",
        LR: "\u041B\u0438\u0431\u0435\u0440\u0438\u044F",
        LS: "\u041B\u0435\u0441\u043E\u0442\u043E",
        LT: "\u041B\u0438\u0442\u0432\u0430",
        LU: "\u041B\u044E\u043A\u0441\u0435\u043C\u0431\u0443\u0440\u0433",
        LV: "\u041B\u0430\u0442\u0432\u0438\u044F",
        LY: "\u041B\u0438\u0432\u0438\u044F",
        MA: "\u041C\u0430\u0440\u043E\u043A\u043A\u043E",
        MC: "\u041C\u043E\u043D\u0430\u043A\u043E",
        MD: "\u041C\u043E\u043B\u0434\u043E\u0432\u0430",
        ME: "\u0427\u0435\u0440\u043D\u043E\u0433\u043E\u0440\u0438\u044F",
        MF: "\u0421\u0435\u043D-\u041C\u0430\u0440\u0442\u0435\u043D",
        MG: "\u041C\u0430\u0434\u0430\u0433\u0430\u0441\u043A\u0430\u0440",
        MH: "\u041C\u0430\u0440\u0448\u0430\u043B\u043B\u043E\u0432\u044B \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        MK: "\u0421\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u044F",
        ML: "\u041C\u0430\u043B\u0438",
        MM: "\u041C\u044C\u044F\u043D\u043C\u0430",
        MN: "\u041C\u043E\u043D\u0433\u043E\u043B\u0438\u044F",
        MO: "\u041C\u0430\u043A\u0430\u043E",
        MP: "\u0421\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u041C\u0430\u0440\u0438\u0430\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        MQ: "\u041C\u0430\u0440\u0442\u0438\u043D\u0438\u043A\u0430",
        MR: "\u041C\u0430\u0432\u0440\u0438\u0442\u0430\u043D\u0438\u044F",
        MS: "\u041C\u043E\u043D\u0442\u0441\u0435\u0440\u0440\u0430\u0442",
        MT: "\u041C\u0430\u043B\u044C\u0442\u0430",
        MU: "\u041C\u0430\u0432\u0440\u0438\u043A\u0438\u0439",
        MV: "\u041C\u0430\u043B\u044C\u0434\u0438\u0432\u044B",
        MW: "\u041C\u0430\u043B\u0430\u0432\u0438",
        MX: "\u041C\u0435\u043A\u0441\u0438\u043A\u0430",
        MY: "\u041C\u0430\u043B\u0430\u0439\u0437\u0438\u044F",
        MZ: "\u041C\u043E\u0437\u0430\u043C\u0431\u0438\u043A",
        NA: "\u041D\u0430\u043C\u0438\u0431\u0438\u044F",
        NC: "\u041D\u043E\u0432\u0430\u044F \u041A\u0430\u043B\u0435\u0434\u043E\u043D\u0438\u044F",
        NE: "\u041D\u0438\u0433\u0435\u0440",
        NF: "\u041E\u0441\u0442\u0440\u043E\u0432 \u041D\u043E\u0440\u0444\u043E\u043B\u043A",
        NG: "\u041D\u0438\u0433\u0435\u0440\u0438\u044F",
        NI: "\u041D\u0438\u043A\u0430\u0440\u0430\u0433\u0443\u0430",
        NL: "\u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u044B",
        NO: "\u041D\u043E\u0440\u0432\u0435\u0433\u0438\u044F",
        NP: "\u041D\u0435\u043F\u0430\u043B",
        NR: "\u041D\u0430\u0443\u0440\u0443",
        NU: "\u041D\u0438\u0443\u044D",
        NZ: "\u041D\u043E\u0432\u0430\u044F \u0417\u0435\u043B\u0430\u043D\u0434\u0438\u044F",
        OM: "\u041E\u043C\u0430\u043D",
        PA: "\u041F\u0430\u043D\u0430\u043C\u0430",
        PE: "\u041F\u0435\u0440\u0443",
        PF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u041F\u043E\u043B\u0438\u043D\u0435\u0437\u0438\u044F",
        PG: "\u041F\u0430\u043F\u0443\u0430 \u2014 \u041D\u043E\u0432\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F",
        PH: "\u0424\u0438\u043B\u0438\u043F\u043F\u0438\u043D\u044B",
        PK: "\u041F\u0430\u043A\u0438\u0441\u0442\u0430\u043D",
        PL: "\u041F\u043E\u043B\u044C\u0448\u0430",
        PM: "\u0421\u0435\u043D-\u041F\u044C\u0435\u0440 \u0438 \u041C\u0438\u043A\u0435\u043B\u043E\u043D",
        PN: "\u041F\u0438\u0442\u043A\u044D\u0440\u043D",
        PR: "\u041F\u0443\u044D\u0440\u0442\u043E-\u0420\u0438\u043A\u043E",
        PS: "\u041F\u0430\u043B\u0435\u0441\u0442\u0438\u043D\u0430",
        PT: "\u041F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u0438\u044F",
        PW: "\u041F\u0430\u043B\u0430\u0443",
        PY: "\u041F\u0430\u0440\u0430\u0433\u0432\u0430\u0439",
        QA: "\u041A\u0430\u0442\u0430\u0440",
        RE: "\u0420\u0435\u044E\u043D\u044C\u043E\u043D",
        RO: "\u0420\u0443\u043C\u044B\u043D\u0438\u044F",
        RS: "\u0421\u0435\u0440\u0431\u0438\u044F",
        RU: "\u0420\u043E\u0441\u0441\u0438\u044F",
        RW: "\u0420\u0443\u0430\u043D\u0434\u0430",
        SA: "\u0421\u0430\u0443\u0434\u043E\u0432\u0441\u043A\u0430\u044F \u0410\u0440\u0430\u0432\u0438\u044F",
        SB: "\u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u044B \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        SC: "\u0421\u0435\u0439\u0448\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
        SD: "\u0421\u0443\u0434\u0430\u043D",
        SE: "\u0428\u0432\u0435\u0446\u0438\u044F",
        SG: "\u0421\u0438\u043D\u0433\u0430\u043F\u0443\u0440",
        SH: "\u041E\u0441\u0442\u0440\u043E\u0432 \u0421\u0432\u044F\u0442\u043E\u0439 \u0415\u043B\u0435\u043D\u044B",
        SI: "\u0421\u043B\u043E\u0432\u0435\u043D\u0438\u044F",
        SJ: "\u0428\u043F\u0438\u0446\u0431\u0435\u0440\u0433\u0435\u043D \u0438 \u042F\u043D-\u041C\u0430\u0439\u0435\u043D",
        SK: "\u0421\u043B\u043E\u0432\u0430\u043A\u0438\u044F",
        SL: "\u0421\u044C\u0435\u0440\u0440\u0430-\u041B\u0435\u043E\u043D\u0435",
        SM: "\u0421\u0430\u043D-\u041C\u0430\u0440\u0438\u043D\u043E",
        SN: "\u0421\u0435\u043D\u0435\u0433\u0430\u043B",
        SO: "\u0421\u043E\u043C\u0430\u043B\u0438",
        SR: "\u0421\u0443\u0440\u0438\u043D\u0430\u043C",
        ST: "\u0421\u0430\u043D-\u0422\u043E\u043C\u0435 \u0438 \u041F\u0440\u0438\u043D\u0441\u0438\u043F\u0438",
        SV: "\u0421\u0430\u043B\u044C\u0432\u0430\u0434\u043E\u0440",
        SY: "\u0421\u0438\u0440\u0438\u044F",
        SZ: "\u042D\u0441\u0432\u0430\u0442\u0438\u043D\u0438",
        TC: "\u0422\u0435\u0440\u043A\u0441 \u0438 \u041A\u0430\u0439\u043A\u043E\u0441",
        TD: "\u0427\u0430\u0434",
        TF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0438\u0435 \u042E\u0436\u043D\u044B\u0435 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438",
        TG: "\u0422\u043E\u0433\u043E",
        TH: "\u0422\u0430\u0438\u043B\u0430\u043D\u0434",
        TJ: "\u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D",
        TK: "\u0422\u043E\u043A\u0435\u043B\u0430\u0443",
        TL: "\u0412\u043E\u0441\u0442\u043E\u0447\u043D\u044B\u0439 \u0422\u0438\u043C\u043E\u0440",
        TM: "\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D",
        TN: "\u0422\u0443\u043D\u0438\u0441",
        TO: "\u0422\u043E\u043D\u0433\u0430",
        TR: "\u0422\u0443\u0440\u0446\u0438\u044F",
        TT: "\u0422\u0440\u0438\u043D\u0438\u0434\u0430\u0434 \u0438 \u0422\u043E\u0431\u0430\u0433\u043E",
        TV: "\u0422\u0443\u0432\u0430\u043B\u0443",
        TW: "\u0422\u0430\u0439\u0432\u0430\u043D\u044C",
        TZ: "\u0422\u0430\u043D\u0437\u0430\u043D\u0438\u044F",
        UA: "\u0423\u043A\u0440\u0430\u0438\u043D\u0430",
        UG: "\u0423\u0433\u0430\u043D\u0434\u0430",
        UM: "\u041C\u0430\u043B\u044B\u0435 \u043E\u0442\u0434\u0430\u043B\u0451\u043D\u043D\u044B\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0428\u0410",
        US: "\u0421\u0428\u0410",
        UY: "\u0423\u0440\u0443\u0433\u0432\u0430\u0439",
        UZ: "\u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D",
        VA: "\u0412\u0430\u0442\u0438\u043A\u0430\u043D",
        VC: "\u0421\u0435\u043D\u0442-\u0412\u0438\u043D\u0441\u0435\u043D\u0442 \u0438 \u0413\u0440\u0435\u043D\u0430\u0434\u0438\u043D\u044B",
        VE: "\u0412\u0435\u043D\u0435\u0441\u0443\u044D\u043B\u0430",
        VG: "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0438\u0435 \u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        VI: "\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0438\u0435 \u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
        VN: "\u0412\u044C\u0435\u0442\u043D\u0430\u043C",
        VU: "\u0412\u0430\u043D\u0443\u0430\u0442\u0443",
        WF: "\u0423\u043E\u043B\u043B\u0438\u0441 \u0438 \u0424\u0443\u0442\u0443\u043D\u0430",
        WS: "\u0421\u0430\u043C\u043E\u0430",
        XK: "\u041A\u043E\u0441\u043E\u0432\u043E",
        YE: "\u0419\u0435\u043C\u0435\u043D",
        YT: "\u041C\u0430\u0439\u043E\u0442\u0442\u0430",
        ZA: "\u042E\u0436\u043D\u043E-\u0410\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
        ZM: "\u0417\u0430\u043C\u0431\u0438\u044F",
        ZW: "\u0417\u0438\u043C\u0431\u0430\u0431\u0432\u0435"
    }
};

});

parcelRegister("7eQgT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df21a18bbad53e8f$export$2e2bcd8739ae039; });
var $df21a18bbad53e8f$export$2e2bcd8739ae039 = {
    calculator: {
        buyLabelName: "\u043C\u0430\u044E",
        swapButtonAriaLabel: "\u043F\u043E\u043C\u0456\u043D\u044F\u0442\u0438 \u0432\u0430\u043B\u044E\u0442\u0438 \u043C\u0456\u0441\u0446\u044F\u043C\u0438",
        sellLabelName: "\u043E\u0442\u0440\u0438\u043C\u0430\u044E",
        currentRate: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u043A\u0443\u0440\u0441:",
        continueButton: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u043E\u0431\u043C\u0456\u043D",
        miniChart: "\u041C\u0456\u043D\u0456\u0433\u0440\u0430\u0444\u0456\u043A \u043F\u043E\u043A\u0430\u0437\u0443\u0454 \u043A\u043E\u043B\u0438\u0432\u0430\u043D\u043D\u044F \u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E\u0433\u043E \u043A\u0443\u0440\u0441\u0443 \u0437\u0430 \u043E\u0441\u0442\u0430\u043D\u043D\u0456 7 \u0434\u043D\u0456\u0432",
        sellTooltip: "\u0426\u0435 \u043A\u0443\u0440\u0441 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 - \u043C\u0438 \u043F\u0440\u043E\u0434\u0430\u0454\u043C\u043E \u0422\u043E\u0431\u0456 {{currency}} \u0437\u0430 {{rate}} PLN. \u0427\u0438\u043C \u043D\u0438\u0436\u0447\u0438\u0439 \u043A\u0443\u0440\u0441, \u0442\u0438\u043C \u0432\u0438\u0433\u0456\u0434\u043D\u0456\u0448\u0435 \u0434\u043B\u044F \u0422\u0435\u0431\u0435. \u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043A\u043E\u0436\u043D\u0456 10 \u0441\u0435\u043A\u0443\u043D\u0434.",
        buyTooltip: "\u0426\u0435 \u043A\u0443\u0440\u0441 \u043A\u0443\u043F\u0456\u0432\u043B\u0456 - \u043C\u0438 \u043A\u0443\u043F\u0443\u0454\u043C\u043E \u0443 \u0442\u0435\u0431\u0435 {{currency}} \u0437\u0430 {{rate}} PLN. \u0427\u0438\u043C \u0432\u0438\u0449\u0438\u0439 \u043A\u0443\u0440\u0441, \u0442\u0438\u043C \u0432\u0438\u0433\u0456\u0434\u043D\u0456\u0448\u0435 \u0434\u043B\u044F \u0422\u0435\u0431\u0435. \u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043A\u043E\u0436\u043D\u0456 10 \u0441\u0435\u043A\u0443\u043D\u0434.",
        saleNotAvailableInfo: "\u041D\u0430\u0440\u0430\u0437\u0456 \u043F\u0440\u043E\u0434\u0430\u0436 \u0443 {{baseCurrency}} \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
        minAmount: "\u041C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u0430 \u0441\u0443\u043C\u0430 \u043E\u0431\u043C\u0456\u043D\u0443 - {{minAmount}} {{minCurrency}}."
    },
    creditCalculator: {
        monthlyLoan: "\u0429\u043E\u043C\u0456\u0441\u044F\u0447\u043D\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436 \u0437\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u043C",
        loanTerm: "\u0414\u043E \u043A\u0456\u043D\u0446\u044F \u043A\u0440\u0435\u0434\u0438\u0442\u0443 \u0437\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044F",
        whichBank: "\u0423 \u044F\u043A\u043E\u043C\u0443 \u0431\u0430\u043D\u043A\u0443 \u0422\u0438 \u043E\u043F\u043B\u0430\u0447\u0443\u0454\u0448 \u043A\u0440\u0435\u0434\u0438\u0442?",
        save: "\u0417\u0430\u043E\u0449\u0430\u0434\u0436\u0443\u0439!",
        years: "\u0440\u043E\u043A\u0456\u0432",
        inYear: "\u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C \u0440\u043E\u043A\u0443",
        toEnd: "\u0434\u043E \u043A\u0456\u043D\u0446\u044F \u043A\u0440\u0435\u0434\u0438\u0442\u0443",
        installmentAmount: "\u0421\u0443\u043C\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0443 \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u043C\u0430\u043B\u0430"
    },
    INTERNAL: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0447\u0435\u0440\u0435\u0437 30 \u0445\u0432\u0438\u043B\u0438\u043D \u043F\u0456\u0441\u043B\u044F \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F \u0422\u0432\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0443, \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
    TODAY: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
    TODAY_OUR: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
    SEPA: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 1 - 2 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
    SEPA_INSTANT: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 1 \u0445\u0432\u0438\u043B\u0438\u043D\u0443.",
    SPOT: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 - 3 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432.",
    ELIXIR: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
    LOCAL: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
    profitCalculator: {
        transferNotSupported: "\u041E\u0431\u0440\u0430\u043D\u0438\u0439 \u0431\u0430\u043D\u043A \u043D\u0435 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0438 \u0446\u0456\u0454\u0457 \u0432\u0430\u043B\u044E\u0442\u0438.",
        transferFree: "\u041C\u0438 \u043D\u0435 \u0441\u0442\u044F\u0433\u0443\u0454\u043C\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439 \u0437\u0430 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043C\u0456\u043D\u044F\u043D\u0438\u0445 \u043A\u043E\u0448\u0442\u0456\u0432!",
        transferFee: "\u0417\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437 \u0434\u043E \u043E\u0431\u0440\u0430\u043D\u043E\u0433\u043E \u0442\u043E\u0431\u043E\u044E \u0431\u0430\u043D\u043A\u0443 \u0441\u0442\u044F\u0433\u0443\u0454\u0442\u044C\u0441\u044F \u0431\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0430 \u043A\u043E\u043C\u0456\u0441\u0456\u044F \u2013 {{transferFee}} PLN. \u041A\u043E\u043C\u0456\u0441\u0456\u044E \u0432\u0436\u0435 \u0432\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E \u0432 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443."
    },
    preactSelect: {
        search: "\u041F\u043E\u0448\u0443\u043A..."
    },
    newsletter: {
        alreadySubscribed: "\u0422\u0432\u043E\u044F \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u0432\u0436\u0435 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u0430 \u043D\u0430 \u043D\u0430\u0448\u0443 \u0440\u043E\u0437\u0441\u0438\u043B\u043A\u0443.",
        error: "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u0421\u043F\u0440\u043E\u0431\u0443\u0439 \u043F\u0456\u0437\u043D\u0456\u0448\u0435."
    },
    frontpageExitPopup: {
        accountExists: "\u0421\u0445\u043E\u0436\u0435, \u0443 \u0422\u0435\u0431\u0435 \u0432\u0436\u0435 \u0454 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441. \u0417\u043D\u0438\u0436\u043A\u0443 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u0454\u043C\u043E \u0434\u043B\u044F \u043D\u043E\u0432\u0438\u0445 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432.",
        error: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430"
    },
    emailValidator: {
        requiredField: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0456\u0434\u043C\u0456\u0442\u0438\u0442\u0438 \u0446\u0435 \u043F\u043E\u043B\u0435",
        notEmptyField: "\u0426\u0435 \u043F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C",
        minValue: "\u041C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u2013",
        maxValue: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u2013",
        incorrectEmail: "\u0412\u0432\u0435\u0434\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
        toShortPassword: "\u041F\u0430\u0440\u043E\u043B\u044C \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439"
    },
    currencyAlert: {
        isLower: "\u0431\u0443\u0434\u0435 \u043D\u0438\u0436\u0447\u0438\u043C",
        isHigher: "\u0431\u0443\u0434\u0435 \u0432\u0438\u0449\u0438\u043C",
        mustBeLessThan: "\u041A\u0443\u0440\u0441 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0447\u0438\u0441\u043B\u043E\u043C \u043C\u0435\u043D\u0448\u0438\u043C \u0437\u0430 99,9999",
        alertAlreadyExists: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043A\u0443\u0440\u0441\u0443 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
        maxAlerts: "\u0422\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0448 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u0442\u0438\u0441\u044F \u043D\u0430 \u0431\u0456\u043B\u044C\u0448\u0443 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C (\u043C\u0430\u043A\u0441. 10)",
        error: "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A, \u0441\u043F\u0440\u043E\u0431\u0443\u0439 \u0437\u0430 \u043C\u0438\u0442\u044C.",
        alertHash: "\u0432\u0430\u043B\u044E\u0442\u043D\u0435-\u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
        averageRateNotAvailable: "\u0417\u0430\u0440\u0430\u0437 \u043D\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F, \u043E\u0441\u043A\u0456\u043B\u044C\u043A\u0438 \u043A\u0443\u0440\u0441 {{currency}} \u0442\u0438\u043C\u0447\u0430\u0441\u043E\u0432\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439 ({{averageRate}})."
    },
    ratesUpdate: {
        update: "\u0422\u0440\u0438\u0432\u0430\u0454 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043A\u0443\u0440\u0441\u0456\u0432...",
        success: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0435 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043A\u0443\u0440\u0441\u0443 \u0447\u0435\u0440\u0435\u0437",
        error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456. \u041F\u043E\u0432\u0442\u043E\u0440\u044E\u0454\u043C\u043E \u0447\u0435\u0440\u0435\u0437"
    },
    currencyAnnotations: {
        notSupported: "\u041E\u0431\u043C\u0456\u043D \u0446\u0456\u0454\u0457 \u0432\u0430\u043B\u044E\u0442\u0438 \u043D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439"
    },
    currencies: {
        AED: "\u0414\u0438\u0440\u0445\u0430\u043C \u041E\u0410\u0415",
        ARS: "\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0441\u043E",
        AUD: "\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        BDT: "\u0411\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0441\u044C\u043A\u0430 \u0442\u0430\u043A\u0430",
        BGN: "\u0411\u043E\u043B\u0433\u0430\u0440\u0441\u044C\u043A\u0438\u0439 \u043B\u0435\u0432",
        BRL: "\u0411\u0440\u0430\u0437\u0438\u043B\u044C\u0441\u044C\u043A\u0438\u0439 \u0440\u0435\u0430\u043B",
        CAD: "\u041A\u0430\u043D\u0430\u0434\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        CHF: "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0441\u044C\u043A\u0438\u0439 \u0444\u0440\u0430\u043D\u043A",
        CLP: "\u0427\u0438\u043B\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0441\u043E",
        CNY: "\u041A\u0438\u0442\u0430\u0439\u0441\u044C\u043A\u0438\u0439 \u044E\u0430\u043D\u044C",
        COP: "\u041A\u043E\u043B\u0443\u043C\u0431\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0441\u043E",
        CZK: "\u0427\u0435\u0441\u044C\u043A\u0430 \u043A\u0440\u043E\u043D\u0430",
        DKK: "\u0414\u0430\u043D\u0441\u044C\u043A\u0430 \u043A\u0440\u043E\u043D\u0430",
        EGP: "\u0404\u0433\u0438\u043F\u0435\u0442\u0441\u044C\u043A\u0438\u0439 \u0444\u0443\u043D\u0442",
        EUR: "\u0404\u0432\u0440\u043E",
        FJD: "\u0424\u0456\u0434\u0436\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        GBP: "\u0424\u0443\u043D\u0442 \u0441\u0442\u0435\u0440\u043B\u0456\u043D\u0433\u0456\u0432",
        GHS: "\u0413\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0441\u0435\u0434\u0456",
        HKD: "\u0413\u043E\u043D\u043A\u043E\u043D\u0433\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        HUF: "\u0423\u0433\u043E\u0440\u0441\u044C\u043A\u0438\u0439 \u0444\u043E\u0440\u0438\u043D\u0442",
        ILS: "\u0406\u0437\u0440\u0430\u0457\u043B\u044C\u0441\u044C\u043A\u0438\u0439 \u043D\u043E\u0432\u0438\u0439 \u0448\u0435\u043A\u0435\u043B\u044C",
        INR: "\u0406\u043D\u0434\u0456\u0439\u0441\u044C\u043A\u0430 \u0440\u0443\u043F\u0456\u044F",
        JOD: "\u0419\u043E\u0440\u0434\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0434\u0438\u043D\u0430\u0440",
        JPY: "\u042F\u043F\u043E\u043D\u0441\u044C\u043A\u0430 \u0454\u043D\u0430",
        KWD: "\u041A\u0443\u0432\u0435\u0439\u0442\u0441\u044C\u043A\u0438\u0439 \u0434\u0438\u043D\u0430\u0440",
        LSL: "\u041C\u0430\u0440\u043E\u043A\u043A\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0434\u0438\u0440\u0445\u0430\u043C",
        MXN: "\u041C\u0435\u043A\u0441\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0441\u043E",
        NOK: "\u041D\u043E\u0440\u0432\u0435\u0437\u044C\u043A\u0430 \u043A\u0440\u043E\u043D\u0430",
        NPR: "\u041D\u0435\u043F\u0430\u043B\u044C\u0441\u044C\u043A\u0430 \u0440\u0443\u043F\u0456\u044F",
        NZD: "\u041D\u043E\u0432\u043E\u0437\u0435\u043B\u0430\u043D\u0434\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        OMR: "\u041E\u043C\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0440\u0456\u0430\u043B",
        PEN: "\u041F\u0435\u0440\u0443\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0441\u043E\u043B\u044C",
        PGK: "\u041A\u0456\u043D\u0430",
        PLN: "\u041F\u043E\u043B\u044C\u0441\u044C\u043A\u0438\u0439 \u0437\u043B\u043E\u0442\u0438\u0439",
        RON: "\u0420\u0443\u043C\u0443\u043D\u0441\u044C\u043A\u0438\u0439 \u043B\u0435\u0439",
        RUB: "\u0420\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0438\u0439 \u0440\u0443\u0431\u043B\u044C",
        SAR: "\u0421\u0430\u0443\u0434\u0456\u0432\u0441\u044C\u043A\u0438\u0439 \u0440\u0456\u0430\u043B",
        SEK: "\u0428\u0432\u0435\u0434\u0441\u044C\u043A\u0430 \u043A\u0440\u043E\u043D\u0430",
        SGD: "\u0421\u0456\u043D\u0433\u0430\u043F\u0443\u0440\u0441\u044C\u043A\u0438\u0439 \u0434\u043E\u043B\u0430\u0440",
        SZL: "\u0421\u0432\u0430\u0437\u0456\u043B\u0435\u043D\u0434\u0441\u044C\u043A\u0438\u0439 \u043B\u0456\u043B\u0430\u043D\u0491\u0435\u043D\u0456",
        THB: "\u0422\u0430\u0439\u0441\u044C\u043A\u0438\u0439 \u0431\u0430\u0442",
        TRY: "\u0422\u0443\u0440\u0435\u0446\u044C\u043A\u0430 \u043B\u0456\u0440\u0430",
        USD: "\u0414\u043E\u043B\u0430\u0440 \u0421\u0428\u0410",
        UYU: "\u0423\u0440\u0443\u0433\u0432\u0430\u0439\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0441\u043E",
        WST: "\u0421\u0430\u043C\u043E\u0430\u043D\u0441\u044C\u043A\u0430 \u0442\u0430\u043B\u0430",
        ZAR: "\u041F\u0456\u0432\u0434\u0435\u043D\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0438\u0439 \u0440\u0430\u043D\u0434"
    },
    currenciesDopelniacz: {
        AED: "\u0434\u0438\u0440\u0445\u0430\u043C\u0430 \u041E\u0410\u0415",
        ARS: "\u0430\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
        AUD: "\u0430\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
        BDT: "\u0431\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0441\u044C\u043A\u043E\u0457 \u0442\u0430\u043A\u0438",
        BGN: "\u0431\u043E\u043B\u0433\u0430\u0440\u0441\u044C\u043A\u043E\u0433\u043E \u043B\u0435\u0432\u0430",
        BRL: "\u0431\u0440\u0430\u0437\u0438\u043B\u044C\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0435\u0430\u043B\u0430",
        CAD: "\u043A\u0430\u043D\u0430\u0434\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
        CHF: "\u0448\u0432\u0435\u0439\u0446\u0430\u0440\u0441\u044C\u043A\u043E\u0433\u043E \u0444\u0440\u0430\u043D\u043A\u0430",
        CNY: "\u043A\u0438\u0442\u0430\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u044E\u0430\u043D\u044F",
        CZK: "\u0447\u0435\u0441\u044C\u043A\u043E\u0457 \u043A\u0440\u043E\u043D\u0438",
        DKK: "\u0434\u0430\u043D\u0441\u044C\u043A\u043E\u0457 \u043A\u0440\u043E\u043D\u0438",
        EGP: "\u0454\u0433\u0438\u043F\u0435\u0442\u0441\u044C\u043A\u043E\u0433\u043E \u0444\u0443\u043D\u0442\u0430",
        EUR: "\u0454\u0432\u0440\u043E",
        FJD: "\u0444\u0456\u0434\u0436\u0456\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
        GBP: "\u0444\u0443\u043D\u0442\u0430 \u0441\u0442\u0435\u0440\u043B\u0456\u043D\u0433\u0456\u0432",
        GHS: "\u0433\u0430\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u0441\u0435\u0434\u0456",
        HKD: "\u0433\u043E\u043D\u043A\u043E\u043D\u0433\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
        INR: "\u0456\u043D\u0434\u0456\u0439\u0441\u044C\u043A\u043E\u0457 \u0440\u0443\u043F\u0456\u0457",
        JOD: "\u0439\u043E\u0440\u0434\u0430\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u0438\u043D\u0430\u0440\u0430",
        KWD: "\u043A\u0443\u0432\u0435\u0439\u0442\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u0438\u043D\u0430\u0440\u0430",
        LSL: "\u043B\u0435\u0441\u043E\u0442\u0441\u044C\u043A\u043E\u0433\u043E \u043B\u043E\u0442\u0456",
        MAD: "\u043C\u0430\u0440\u043E\u043A\u043A\u0430\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u0438\u0440\u0445\u0430\u043C\u0430",
        MXN: "\u043C\u0435\u043A\u0441\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
        NOK: "\u043D\u043E\u0440\u0432\u0435\u0437\u044C\u043A\u043E\u0457 \u043A\u0440\u043E\u043D\u0438",
        NPR: "\u043D\u0435\u043F\u0430\u043B\u044C\u0441\u044C\u043A\u043E\u0457 \u0440\u0443\u043F\u0456\u0457",
        NZD: "\u043D\u043E\u0432\u043E\u0437\u0435\u043B\u0430\u043D\u0434\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
        OMR: "\u043E\u043C\u0430\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0456\u0430\u043B\u0430",
        PEN: "\u043F\u0435\u0440\u0443\u0430\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u0441\u043E\u043B\u044F",
        PGK: "\u043F\u0430\u043F\u0443\u0430\u0441\u044C\u043A\u043E\u0457 \u043A\u0456\u043D\u0438",
        PLN: "\u043F\u043E\u043B\u044C\u0441\u044C\u043A\u043E\u0433\u043E \u0437\u043B\u043E\u0442\u043E\u0433\u043E",
        RON: "\u0440\u0443\u043C\u0443\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u043B\u0435\u044F",
        RUB: "\u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0443\u0431\u043B\u044F",
        SAR: "\u0441\u0430\u0443\u0434\u0456\u0432\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0456\u0430\u043B\u0430",
        SEK: "\u0448\u0432\u0435\u0434\u0441\u044C\u043A\u043E\u0457 \u043A\u0440\u043E\u043D\u0438",
        SGD: "\u0441\u0456\u043D\u0433\u0430\u043F\u0443\u0440\u0441\u044C\u043A\u043E\u0433\u043E \u0434\u043E\u043B\u0430\u0440\u0430",
        SZL: "\u043B\u0456\u043B\u0430\u043D\u0433\u0435\u043D\u0456 \u0441\u0432\u0430\u0437\u0456\u043B\u0435\u043D\u0434\u0443",
        THB: "\u0442\u0430\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u0431\u0430\u0442\u0430",
        TRY: "\u0442\u0443\u0440\u0435\u0446\u044C\u043A\u043E\u0457 \u043B\u0456\u0440\u0438",
        USD: "\u0434\u043E\u043B\u0430\u0440\u0430 \u0421\u0428\u0410",
        UYU: "\u0443\u0440\u0443\u0433\u0432\u0430\u0439\u0441\u044C\u043A\u043E\u0433\u043E \u043F\u0435\u0441\u043E",
        WST: "\u0441\u0430\u043C\u043E\u0430\u043D\u0441\u044C\u043A\u043E\u0457 \u0442\u0430\u043B\u0438",
        ZAR: "\u043F\u0456\u0432\u0434\u0435\u043D\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0430\u043D\u0434\u0430"
    },
    chart: {
        time: "\u0427\u0430\u0441",
        rate: "\u041A\u0443\u0440\u0441",
        opening: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F",
        highest: "\u041D\u0430\u0439\u0432\u0438\u0449\u0438\u0439",
        lowest: "\u041D\u0430\u0439\u043D\u0438\u0436\u0447\u0438\u0439",
        closing: "\u0417\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
        monthNames: [
            "\u0441\u0456\u0447",
            "\u043B\u044E\u0442",
            "\u0431\u0435\u0440",
            "\u043A\u0432\u0456",
            "\u0442\u0440\u0430",
            "\u0447\u0435\u0440",
            "\u043B\u0438\u043F",
            "\u0441\u0435\u0440",
            "\u0432\u0435\u0440",
            "\u0436\u043E\u0432",
            "\u043B\u0438\u0441",
            "\u0433\u0440\u0443"
        ],
        dayNames: [
            "\u043F\u043D",
            "\u0432\u0442",
            "\u0441\u0440",
            "\u0447\u0442",
            "\u043F\u0442",
            "\u0441\u0431",
            "\u043D\u0434"
        ]
    },
    landingForm: {
        show: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438",
        hide: "\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438",
        requiredField: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0456\u0434\u043C\u0456\u0442\u0438\u0442\u0438 \u0446\u0435 \u043F\u043E\u043B\u0435",
        notEmptyField: "\u0426\u0435 \u043F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C",
        incorrectEmail: "\u0412\u0432\u0435\u0434\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
        toShortPassword: "\u041F\u0430\u0440\u043E\u043B\u044C \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439",
        invalidPromocode: "\u0410\u043A\u0446\u0456\u044F \u043D\u0430 \u0446\u0456\u0439 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u0432\u0436\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u043B\u0438\u0441\u044F - \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0439\u0441\u044F \u0447\u0435\u0440\u0435\u0437 \u0433\u043E\u043B\u043E\u0432\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
        emailAlreadyExists: "\u0426\u044E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0442\u0438 \u0434\u043B\u044F \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0457",
        generalInvalid: "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A, \u0441\u043F\u0440\u043E\u0431\u0443\u0439 \u043F\u0456\u0437\u043D\u0456\u0448\u0435",
        competitionFormThanks: "\u0414\u044F\u043A\u0443\u0454\u043C\u043E \u0437\u0430 \u0443\u0447\u0430\u0441\u0442\u044C \u0443 \u043A\u043E\u043D\u043A\u0443\u0440\u0441\u0456!"
    },
    networkErrorStatus: {
        slow: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0456\u0437 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u043C \u043A\u0443\u0440\u0441\u0456\u0432 \u0432\u0430\u043B\u044E\u0442. \u041F\u043E\u0432\u0456\u043B\u044C\u043D\u0435 \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u0437\u02BC\u0454\u0434\u043D\u0430\u043D\u043D\u044F.",
        noNetwork: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0456\u0437 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u043C \u043A\u0443\u0440\u0441\u0456\u0432 \u0432\u0430\u043B\u044E\u0442. \u041F\u0435\u0440\u0435\u0432\u0456\u0440, \u0447\u0438 \u0454 \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u0437\u02BC\u0454\u0434\u043D\u0430\u043D\u043D\u044F.",
        default: "\u0412\u0438\u043D\u0438\u043A\u043B\u0438 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u0456 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438. \u0417\u0432\u0435\u0440\u043D\u0438\u0441\u044C \u0434\u043E \u0412\u0456\u0434\u0434\u0456\u043B\u0443 \u041E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F \u041A\u043B\u0456\u0454\u043D\u0442\u0430."
    },
    calculatorForegin: {
        continueButton: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u043E\u0431\u043C\u0456\u043D",
        exchangeRates: "\u041A\u0443\u0440\u0441 \u043E\u0431\u043C\u0456\u043D\u0443",
        details: "\u0414\u0435\u0442\u0430\u043B\u0456",
        amountYouSend: "\u0421\u0443\u043C\u0430, \u044F\u043A\u0443 \u044F \u0432\u043D\u043E\u0448\u0443",
        countryYouSendMoney: "\u041A\u0440\u0430\u0457\u043D\u0430, \u0434\u043E \u044F\u043A\u043E\u0457 \u0422\u0438 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u0454\u0448 \u0433\u0440\u043E\u0448\u0456",
        foreignTransferFee: "\u041A\u043E\u043C\u0456\u0441\u0456\u044F \u0437\u0430 \u043C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0438\u0439 \u043F\u0435\u0440\u0435\u043A\u0430\u0437",
        foreignTransferType: "\u0422\u0438\u043F \u043C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0443",
        exchangeAmount: "\u0421\u0443\u043C\u0430 \u043E\u0431\u043C\u0456\u043D\u0443",
        amountRecipientReceive: "\u0421\u0443\u043C\u0430, \u044F\u043A\u0443 \u043E\u0442\u0440\u0438\u043C\u0430\u0454 \u043E\u0434\u0435\u0440\u0436\u0443\u0432\u0430\u0447",
        minAmount: "\u0421\u0443\u043C\u0430 \u043E\u0431\u043C\u0456\u043D\u0443 \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u043C\u0430\u043B\u0430.",
        notSellCurrency: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0432\u0430\u043B\u044E\u0442\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439.",
        transferTypes: {
            INTERNAL: {
                name: 'INTERNAL',
                desc: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0447\u0435\u0440\u0435\u0437 30 \u0445\u0432\u0438\u043B\u0438\u043D \u043F\u0456\u0441\u043B\u044F \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F \u0422\u0432\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u0443, \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F."
            },
            TODAY: {
                name: 'TODAY',
                desc: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F."
            },
            TODAY_OUR: {
                name: 'TODAY OUR',
                desc: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F."
            },
            SEPA: {
                name: 'SEPA',
                desc: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 1 - 2 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432."
            },
            SEPA_INSTANT: {
                name: 'SEPA INSTANT',
                desc: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 1 \u0445\u0432\u0438\u043B\u0438\u043D\u0443."
            },
            SPOT: {
                name: 'SPOT',
                desc: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 - 3 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432."
            },
            ELIXIR: {
                name: 'ELIXIR',
                desc: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F."
            },
            LOCAL: {
                name: 'LOCAL',
                desc: "\u0413\u0440\u043E\u0448\u0456 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C \u043D\u0430\u0439\u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F."
            }
        }
    },
    timer: {
        update: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0447\u0435\u0440\u0435\u0437:",
        timeUnit: "\u0441\u0435\u043A."
    },
    countries: {
        AD: "\u0410\u043D\u0434\u043E\u0440\u0440\u0430",
        AE: "\u041E\u0431\u02BC\u0454\u0434\u043D\u0430\u043D\u0456 \u0410\u0440\u0430\u0431\u0441\u044C\u043A\u0456 \u0415\u043C\u0456\u0440\u0430\u0442\u0438",
        AF: "\u0410\u0444\u0433\u0430\u043D\u0456\u0441\u0442\u0430\u043D",
        AG: "\u0410\u043D\u0442\u0438\u0433\u0443\u0430 \u0456 \u0411\u0430\u0440\u0431\u0443\u0434\u0430",
        AI: "\u0410\u043D\u0433\u0456\u043B\u044C\u044F",
        AL: "\u0410\u043B\u0431\u0430\u043D\u0456\u044F",
        AM: "\u0412\u0456\u0440\u043C\u0435\u043D\u0456\u044F",
        AN: "\u041D\u0456\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0441\u044C\u043A\u0456 \u0410\u043D\u0442\u0438\u043B\u044C\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        AO: "\u0410\u043D\u0433\u043E\u043B\u0430",
        AQ: "\u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0434\u0430",
        AR: "\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0430",
        AS: "\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0435 \u0421\u0430\u043C\u043E\u0430",
        AT: "\u0410\u0432\u0441\u0442\u0440\u0456\u044F",
        AU: "\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0456\u044F",
        AW: "\u0410\u0440\u0443\u0431\u0430",
        AX: "\u0410\u043B\u0430\u043D\u0434\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        AZ: "\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D",
        BA: "\u0411\u043E\u0441\u043D\u0456\u044F \u0456 \u0413\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430",
        BB: "\u0411\u0430\u0440\u0431\u0430\u0434\u043E\u0441",
        BD: "\u0411\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448",
        BE: "\u0411\u0435\u043B\u044C\u0433\u0456\u044F",
        BF: "\u0411\u0443\u0440\u043A\u0456\u043D\u0430-Fac\u043E",
        BG: "\u0411\u043E\u043B\u0433\u0430\u0440\u0456\u044F",
        BH: "\u0411\u0430\u0445\u0440\u0435\u0439\u043D",
        BI: "\u0411\u0443\u0440\u0443\u043D\u0434\u0456",
        BJ: "\u0411\u0435\u043D\u0456\u043D",
        BL: "\u0421\u0435\u043D-\u0411\u0430\u0440\u0442\u0435\u043B\u0435\u043C\u0456",
        BM: "\u0411\u0435\u0440\u043C\u0443\u0434\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        BN: "\u0411\u0440\u0443\u043D\u0435\u0439",
        BO: "\u0411\u043E\u043B\u0456\u0432\u0456\u044F",
        BR: "\u0411\u0440\u0430\u0437\u0438\u043B\u0456\u044F",
        BS: "\u0411\u0430\u0433\u0430\u043C\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        BT: "\u0411\u0443\u0442\u0430\u043D",
        BV: "\u041E\u0441\u0442\u0440\u0456\u0432 \u0411\u0443\u0432\u0435",
        BW: "\u0411\u043E\u0442\u0441\u0432\u0430\u043D\u0430",
        BY: "\u0411\u0456\u043B\u043E\u0440\u0443\u0441\u044C",
        BZ: "\u0411\u0435\u043B\u0456\u0437",
        CA: "\u041A\u0430\u043D\u0430\u0434\u0430",
        CC: "\u041A\u043E\u043A\u043E\u0441\u043E\u0432\u0456 (\u041A\u0456\u043B\u0456\u043D\u0433) \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        CD: "\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u043D\u0430 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430 \u041A\u043E\u043D\u0433\u043E",
        CF: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0430 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430",
        CG: "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043D\u0433\u043E",
        CH: "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0456\u044F",
        CI: "\u041A\u043E\u0442-\u0434\u02BC\u0406\u0432\u0443\u0430\u0440",
        CK: "\u041E\u0441\u0442\u0440\u043E\u0432\u0438 \u041A\u0443\u043A\u0430",
        CL: "\u0427\u0438\u043B\u0456",
        CM: "\u041A\u0430\u043C\u0435\u0440\u0443\u043D",
        CN: "\u041A\u0438\u0442\u0430\u0439",
        CO: "\u041A\u043E\u043B\u0443\u043C\u0431\u0456\u044F",
        CR: "\u041A\u043E\u0441\u0442\u0430-\u0420\u0438\u043A\u0430",
        CU: "\u041A\u0443\u0431\u0430",
        CV: "\u041A\u0430\u0431\u043E-\u0412\u0435\u0440\u0434\u0435",
        CW: "\u041A\u044E\u0440\u0430\u0441\u0430\u043E",
        CX: "\u041E\u0441\u0442\u0440\u0456\u0432 \u0420\u0456\u0437\u0434\u0432\u0430",
        CY: "\u041A\u0456\u043F\u0440",
        CZ: "\u0427\u0435\u0445\u0456\u044F",
        DE: "\u041D\u0456\u043C\u0435\u0447\u0447\u0438\u043D\u0430",
        DJ: "\u0414\u0436\u0438\u0431\u0443\u0442\u0456",
        DK: "\u0414\u0430\u043D\u0456\u044F",
        DM: "\u0414\u043E\u043C\u0456\u043D\u0456\u043A\u0430",
        DO: "\u0414\u043E\u043C\u0456\u043D\u0456\u043A\u0430\u043D\u0441\u044C\u043A\u0430 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430",
        DZ: "\u0410\u043B\u0436\u0438\u0440",
        EC: "\u0415\u043A\u0432\u0430\u0434\u043E\u0440",
        EE: "\u0415\u0441\u0442\u043E\u043D\u0456\u044F",
        EG: "\u0404\u0433\u0438\u043F\u0435\u0442",
        EH: "\u0417\u0430\u0445\u0456\u0434\u043D\u0430 \u0421\u0430\u0445\u0430\u0440\u0430",
        ER: "\u0415\u0440\u0438\u0442\u0440\u0435\u044F",
        ES: "\u0406\u0441\u043F\u0430\u043D\u0456\u044F",
        ET: "\u0415\u0444\u0456\u043E\u043F\u0456\u044F",
        FI: "\u0424\u0456\u043D\u043B\u044F\u043D\u0434\u0456\u044F",
        FJ: "\u0424\u0456\u0434\u0436\u0456",
        FK: "\u0424\u043E\u043B\u043A\u043B\u0435\u043D\u0434\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        FM: "\u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0456 \u0428\u0442\u0430\u0442\u0438 \u041C\u0456\u043A\u0440\u043E\u043D\u0435\u0437\u0456\u0457",
        FO: "\u0424\u0430\u0440\u0435\u0440\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        FR: "\u0424\u0440\u0430\u043D\u0446\u0456\u044F",
        GA: "\u0413\u0430\u0431\u043E\u043D",
        GB: "\u0412\u0435\u043B\u0438\u043A\u0430 \u0411\u0440\u0438\u0442\u0430\u043D\u0456\u044F",
        GD: "\u0413\u0440\u0435\u043D\u0430\u0434\u0430",
        GE: "\u0413\u0440\u0443\u0437\u0456\u044F",
        GF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u044C\u043A\u0430 \u0413\u0432\u0456\u0430\u043D\u0430",
        GG: "\u0413\u0435\u0440\u043D\u0441\u0456",
        GH: "\u0413\u0430\u043D\u0430",
        GI: "\u0413\u0456\u0431\u0440\u0430\u043B\u0442\u0430\u0440",
        GL: "\u0413\u0440\u0435\u043D\u043B\u0430\u043D\u0434\u0456\u044F",
        GM: "\u0413\u0430\u043C\u0431\u0456\u044F",
        GN: "\u0413\u0432\u0456\u043D\u0435\u044F",
        GP: "\u0413\u0432\u0430\u0434\u0435\u043B\u0443\u043F\u0430",
        GQ: "\u0415\u043A\u0432\u0430\u0442\u043E\u0440\u0456\u0430\u043B\u044C\u043D\u0430 \u0413\u0432\u0456\u043D\u0435\u044F",
        GR: "\u0413\u0440\u0435\u0446\u0456\u044F",
        GS: "\u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0430 \u0414\u0436\u043E\u0440\u0434\u0436\u0456\u044F \u0442\u0430 \u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0456 \u0421\u0430\u043D\u0434\u0432\u0456\u0447\u0435\u0432\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        GT: "\u0413\u0432\u0430\u0442\u0435\u043C\u0430\u043B\u0430",
        GU: "\u0413\u0443\u0430\u043C",
        GW: "\u0413\u0432\u0456\u043D\u0435\u044F-\u0411\u0456\u0441\u0430\u0443",
        GY: "\u0413\u0430\u044F\u043D\u0430",
        HK: "\u0413\u043E\u043D\u043A\u043E\u043D\u0433",
        HM: "\u041E\u0441\u0442\u0440\u043E\u0432\u0438 \u0413\u0435\u0440\u0434 \u0456 \u041C\u0430\u043A\u0434\u043E\u043D\u0430\u043B\u044C\u0434",
        HN: "\u0413\u043E\u043D\u0434\u0443\u0440\u0430\u0441",
        HR: "\u0425\u043E\u0440\u0432\u0430\u0442\u0456\u044F",
        HT: "\u0413\u0430\u0457\u0442\u0456",
        HU: "\u0423\u0433\u043E\u0440\u0449\u0438\u043D\u0430",
        ID: "\u0406\u043D\u0434\u043E\u043D\u0435\u0437\u0456\u044F",
        IE: "\u0406\u0440\u043B\u0430\u043D\u0434\u0456\u044F",
        IL: "\u0406\u0437\u0440\u0430\u0457\u043B\u044C",
        IM: "\u041E\u0441\u0442\u0440\u0456\u0432 \u041C\u0435\u043D",
        IN: "\u0406\u043D\u0434\u0456\u044F",
        IO: "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u044C\u043A\u0430 \u0442\u0435\u0440\u0438\u0442\u043E\u0440\u0456\u044F \u0432 \u0406\u043D\u0434\u0456\u0439\u0441\u044C\u043A\u043E\u043C\u0443 \u043E\u043A\u0435\u0430\u043D\u0456",
        IQ: "\u0406\u0440\u0430\u043A",
        IR: "\u0406\u0440\u0430\u043D",
        IS: "\u0406\u0441\u043B\u0430\u043D\u0434\u0456\u044F",
        IT: "\u0406\u0442\u0430\u043B\u0456\u044F",
        JE: "\u0414\u0436\u0435\u0440\u0441\u0456",
        JM: "\u042F\u043C\u0430\u0439\u043A\u0430",
        JO: "\u0419\u043E\u0440\u0434\u0430\u043D\u0456\u044F",
        JP: "\u042F\u043F\u043E\u043D\u0456\u044F",
        KE: "\u041A\u0435\u043D\u0456\u044F",
        KG: "\u041A\u0438\u0440\u0433\u0438\u0437\u0441\u0442\u0430\u043D",
        KH: "\u041A\u0430\u043C\u0431\u043E\u0434\u0436\u0430",
        KI: "\u041A\u0456\u0440\u0438\u0431\u0430\u0442\u0456",
        KM: "\u041A\u043E\u043C\u043E\u0440\u0438",
        KN: "\u0421\u0435\u043D\u0442-\u041A\u0456\u0442\u0441 \u0456 \u041D\u0435\u0432\u0456\u0441",
        KP: "\u041A\u041D\u0414\u0420",
        KR: "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430 \u041A\u043E\u0440\u0435\u044F",
        KW: "\u041A\u0443\u0432\u0435\u0439\u0442",
        KY: "\u041A\u0430\u0439\u043C\u0430\u043D\u043E\u0432\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        KZ: "\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D",
        LA: "\u041B\u0430\u043E\u0441",
        LB: "\u041B\u0456\u0432\u0430\u043D",
        LC: "\u0421\u0435\u043D\u0442-\u041B\u044E\u0441\u0456\u044F",
        LI: "\u041B\u0456\u0445\u0442\u0435\u043D\u0448\u0442\u0435\u0439\u043D",
        LK: "\u0428\u0440\u0456-\u041B\u0430\u043D\u043A\u0430",
        LR: "\u041B\u0456\u0431\u0435\u0440\u0456\u044F",
        LS: "\u041B\u0435\u0441\u043E\u0442\u043E",
        LT: "\u041B\u0438\u0442\u0432\u0430",
        LU: "\u041B\u044E\u043A\u0441\u0435\u043C\u0431\u0443\u0440\u0433",
        LV: "\u041B\u0430\u0442\u0432\u0456\u044F",
        LY: "\u041B\u0456\u0432\u0456\u044F",
        MA: "\u041C\u0430\u0440\u043E\u043A\u043A\u043E",
        MC: "\u041C\u043E\u043D\u0430\u043A\u043E",
        MD: "\u041C\u043E\u043B\u0434\u043E\u0432\u0430",
        ME: "\u0427\u043E\u0440\u043D\u043E\u0433\u043E\u0440\u0456\u044F",
        MF: "\u0421\u0435\u043D-\u041C\u0430\u0440\u0442\u0435\u043D",
        MG: "\u041C\u0430\u0434\u0430\u0433\u0430\u0441\u043A\u0430\u0440",
        MH: "\u041C\u0430\u0440\u0448\u0430\u043B\u043B\u043E\u0432\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        MK: "\u041F\u0456\u0432\u043D\u0456\u0447\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0456\u044F",
        ML: "\u041C\u0430\u043B\u0456",
        MM: "\u041C\u02BC\u044F\u043D\u043C\u0430",
        MN: "\u041C\u043E\u043D\u0433\u043E\u043B\u0456\u044F",
        MO: "\u041C\u0430\u043A\u0430\u043E",
        MP: "\u041F\u0456\u0432\u043D\u0456\u0447\u043D\u0456 \u041C\u0430\u0440\u0456\u0430\u043D\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        MQ: "\u041C\u0430\u0440\u0442\u0438\u043D\u0456\u043A\u0430",
        MR: "\u041C\u0430\u0432\u0440\u0438\u0442\u0430\u043D\u0456\u044F",
        MS: "\u041C\u043E\u043D\u0442\u0441\u0435\u0440\u0440\u0430\u0442",
        MT: "\u041C\u0430\u043B\u044C\u0442\u0430",
        MU: "\u041C\u0430\u0432\u0440\u0438\u043A\u0456\u0439",
        MV: "\u041C\u0430\u043B\u044C\u0434\u0456\u0432\u0438",
        MW: "\u041C\u0430\u043B\u0430\u0432\u0456",
        MX: "\u041C\u0435\u043A\u0441\u0438\u043A\u0430",
        MY: "\u041C\u0430\u043B\u0430\u0439\u0437\u0456\u044F",
        MZ: "\u041C\u043E\u0437\u0430\u043C\u0431\u0456\u043A",
        NA: "\u041D\u0430\u043C\u0456\u0431\u0456\u044F",
        NC: "\u041D\u043E\u0432\u0430 \u041A\u0430\u043B\u0435\u0434\u043E\u043D\u0456\u044F",
        NE: "\u041D\u0456\u0433\u0435\u0440",
        NF: "\u041E\u0441\u0442\u0440\u0456\u0432 \u041D\u043E\u0440\u0444\u043E\u043B\u043A",
        NG: "\u041D\u0456\u0433\u0435\u0440\u0456\u044F",
        NI: "\u041D\u0456\u043A\u0430\u0440\u0430\u0433\u0443\u0430",
        NL: "\u041D\u0456\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0438",
        NO: "\u041D\u043E\u0440\u0432\u0435\u0433\u0456\u044F",
        NP: "\u041D\u0435\u043F\u0430\u043B",
        NR: "\u041D\u0430\u0443\u0440\u0443",
        NU: "\u041D\u0456\u0443\u0435",
        NZ: "\u041D\u043E\u0432\u0430 \u0417\u0435\u043B\u0430\u043D\u0434\u0456\u044F",
        OM: "\u041E\u043C\u0430\u043D",
        PA: "\u041F\u0430\u043D\u0430\u043C\u0430",
        PE: "\u041F\u0435\u0440\u0443",
        PF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u044C\u043A\u0430 \u041F\u043E\u043B\u0456\u043D\u0435\u0437\u0456\u044F",
        PG: "\u041F\u0430\u043F\u0443\u0430-\u041D\u043E\u0432\u0430 \u0413\u0432\u0456\u043D\u0435\u044F",
        PH: "\u0424\u0456\u043B\u0456\u043F\u043F\u0456\u043D\u0438",
        PK: "\u041F\u0430\u043A\u0438\u0441\u0442\u0430\u043D",
        PL: "\u041F\u043E\u043B\u044C\u0449\u0430",
        PM: "\u0421\u0435\u043D-\u041F\u02BC\u0454\u0440 \u0456 \u041C\u0456\u043A\u0435\u043B\u043E\u043D",
        PN: "\u041F\u0456\u0442\u043A\u0435\u0440\u043D",
        PR: "\u041F\u0443\u0435\u0440\u0442\u043E-\u0420\u0438\u043A\u043E",
        PS: "\u041F\u0430\u043B\u0435\u0441\u0442\u0438\u043D\u0430",
        PT: "\u041F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u0456\u044F",
        PW: "\u041F\u0430\u043B\u0430\u0443",
        PY: "\u041F\u0430\u0440\u0430\u0433\u0432\u0430\u0439",
        QA: "\u041A\u0430\u0442\u0430\u0440",
        RE: "\u0420\u0435\u044E\u043D\u044C\u0439\u043E\u043D",
        RO: "\u0420\u0443\u043C\u0443\u043D\u0456\u044F",
        RS: "\u0421\u0435\u0440\u0431\u0456\u044F",
        RU: "\u0420\u043E\u0441\u0456\u044F",
        RW: "\u0420\u0443\u0430\u043D\u0434\u0430",
        SA: "\u0421\u0430\u0443\u0434\u0456\u0432\u0441\u044C\u043A\u0430 \u0410\u0440\u0430\u0432\u0456\u044F",
        SB: "\u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        SC: "\u0421\u0435\u0439\u0448\u0435\u043B\u044C\u0441\u044C\u043A\u0456 \u041E\u0441\u0442\u0440\u043E\u0432\u0438",
        SD: "\u0421\u0443\u0434\u0430\u043D",
        SE: "\u0428\u0432\u0435\u0446\u0456\u044F",
        SGD: "\u0421\u0456\u043D\u0433\u0430\u043F\u0443\u0440",
        SH: "\u041E\u0441\u0442\u0440\u0456\u0432 \u0421\u0432\u044F\u0442\u043E\u0457 \u0404\u043B\u0435\u043D\u0438",
        SI: "\u0421\u043B\u043E\u0432\u0435\u043D\u0456\u044F",
        SJ: "\u0421\u0432\u0430\u043B\u044C\u0431\u0430\u0440\u0434 \u0456 \u042F\u043D-\u041C\u0430\u0454\u043D",
        SK: "\u0421\u043B\u043E\u0432\u0430\u0447\u0447\u0438\u043D\u0430",
        SL: "\u0421\u044C\u0454\u0440\u0440\u0430-\u041B\u0435\u043E\u043D\u0435",
        SM: "\u0421\u0430\u043D-\u041C\u0430\u0440\u0438\u043D\u043E",
        SN: "\u0421\u0435\u043D\u0435\u0433\u0430\u043B",
        SO: "\u0421\u043E\u043C\u0430\u043B\u0456",
        SR: "\u0421\u0443\u0440\u0438\u043D\u0430\u043C",
        ST: "\u0421\u0430\u043D-\u0422\u043E\u043C\u0435 \u0456 \u041F\u0440\u0438\u043D\u0441\u0456\u043F\u0456",
        SV: "\u0421\u0430\u043B\u044C\u0432\u0430\u0434\u043E\u0440",
        SY: "\u0421\u0438\u0440\u0456\u044F",
        SZ: "\u0415\u0441\u0432\u0430\u0442\u0456\u043D\u0456",
        TC: "\u0422\u0435\u0440\u043A\u0441 \u0456 \u041A\u0430\u0439\u043A\u043E\u0441",
        TD: "\u0427\u0430\u0434",
        TF: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u044C\u043A\u0456 \u041F\u0456\u0432\u0434\u0435\u043D\u043D\u0456 \u0442\u0435\u0440\u0438\u0442\u043E\u0440\u0456\u0457",
        TG: "\u0422\u043E\u0433\u043E",
        TH: "\u0422\u0430\u0457\u043B\u0430\u043D\u0434",
        TJ: "\u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D",
        TK: "\u0422\u043E\u043A\u0435\u043B\u0430\u0443",
        TL: "\u0421\u0445\u0456\u0434\u043D\u0438\u0439 \u0422\u0438\u043C\u043E\u0440",
        TM: "\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0456\u0441\u0442\u0430\u043D",
        TN: "\u0422\u0443\u043D\u0456\u0441",
        TO: "\u0422\u043E\u043D\u0433\u0430",
        TR: "\u0422\u0443\u0440\u0435\u0447\u0447\u0438\u043D\u0430",
        TT: "\u0422\u0440\u0438\u043D\u0456\u0434\u0430\u0434 \u0456 \u0422\u043E\u0431\u0430\u0433\u043E",
        TV: "\u0422\u0443\u0432\u0430\u043B\u0443",
        TW: "\u0422\u0430\u0439\u0432\u0430\u043D\u044C",
        TZ: "\u0422\u0430\u043D\u0437\u0430\u043D\u0456\u044F",
        UA: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
        UG: "\u0423\u0433\u0430\u043D\u0434\u0430",
        UM: "\u041C\u0430\u043B\u0456 \u0432\u0456\u0434\u0434\u0430\u043B\u0435\u043D\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438 \u0421\u0428\u0410",
        US: "\u0421\u0428\u0410",
        UY: "\u0423\u0440\u0443\u0433\u0432\u0430\u0439",
        UZ: "\u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D",
        VA: "\u0412\u0430\u0442\u0438\u043A\u0430\u043D",
        VC: "\u0421\u0435\u043D\u0442-\u0412\u0456\u043D\u0441\u0435\u043D\u0442 \u0456 \u0413\u0440\u0435\u043D\u0430\u0434\u0438\u043D\u0438",
        VE: "\u0412\u0435\u043D\u0435\u0441\u0443\u0435\u043B\u0430",
        VG: "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u044C\u043A\u0456 \u0412\u0456\u0440\u0433\u0456\u043D\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        VI: "\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0456 \u0412\u0456\u0440\u0433\u0456\u043D\u0441\u044C\u043A\u0456 \u043E\u0441\u0442\u0440\u043E\u0432\u0438",
        VN: "\u0412\u02BC\u0454\u0442\u043D\u0430\u043C",
        VU: "\u0412\u0430\u043D\u0443\u0430\u0442\u0443",
        WF: "\u0412\u043E\u043B\u043B\u0456\u0441 \u0456 \u0424\u0443\u0442\u0443\u043D\u0430",
        WS: "\u0421\u0430\u043C\u043E\u0430",
        XK: "\u041A\u043E\u0441\u043E\u0432\u043E",
        YE: "\u0404\u043C\u0435\u043D",
        YT: "\u041C\u0430\u0439\u043E\u0442\u0442\u0430",
        ZA: "\u041F\u0456\u0432\u0434\u0435\u043D\u043D\u043E-\u0410\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u044C\u043A\u0430 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430",
        ZM: "\u0417\u0430\u043C\u0431\u0456\u044F",
        ZW: "\u0417\u0456\u043C\u0431\u0430\u0431\u0432\u0435"
    }
};

});


parcelRegister("cctvf", function(module, exports) {

$parcel$export(module.exports, "checkedValidator", function () { return $c848bb82e2af39d0$export$c59e67bad9d6ec8; });
$parcel$export(module.exports, "emptyValidator", function () { return $c848bb82e2af39d0$export$baa4514a76cc1deb; });
$parcel$export(module.exports, "minValueValidator", function () { return $c848bb82e2af39d0$export$50a71eb254648fd1; });
$parcel$export(module.exports, "maxValueValidator", function () { return $c848bb82e2af39d0$export$e0556960bec3691e; });
$parcel$export(module.exports, "emailValidator", function () { return $c848bb82e2af39d0$export$85e9422a5732c151; });
$parcel$export(module.exports, "passwordValidator", function () { return $c848bb82e2af39d0$export$5fe07b64a9ea357e; });
$parcel$export(module.exports, "averageRateValidator", function () { return $c848bb82e2af39d0$export$c6a00b1b1a7803e7; });

var $3cM09 = parcelRequire("3cM09");

var $655Fc = parcelRequire("655Fc");

var $daEfo = parcelRequire("daEfo");
const $c848bb82e2af39d0$export$c59e67bad9d6ec8 = (value)=>(0, $3cM09.isValueValidator)(value) ? '' : (0, $daEfo.t9n)('emailValidator.requiredField');
const $c848bb82e2af39d0$export$baa4514a76cc1deb = (value)=>(0, $3cM09.isValueValidator)(value) ? '' : (0, $daEfo.t9n)('emailValidator.notEmptyField');
const $c848bb82e2af39d0$export$50a71eb254648fd1 = (minValue)=>(value)=>(0, $3cM09.isNotSmallerValidator)((0, $655Fc.localeStringToFloat)(value), (0, $655Fc.localeStringToFloat)(minValue)) ? '' : `${(0, $daEfo.t9n)('emailValidator.minValue')} ${minValue}`;
const $c848bb82e2af39d0$export$42c536222dfa9095 = (minValue)=>(value)=>(0, $3cM09.isNotSmallerOrEqualValidator)((0, $655Fc.localeStringToFloat)(value), (0, $655Fc.localeStringToFloat)(minValue)) ? '' : `${(0, $daEfo.t9n)('emailValidator.minValue')} ${minValue}`;
const $c848bb82e2af39d0$export$e0556960bec3691e = (maxValue)=>(value)=>(0, $3cM09.isNotHigherValidator)((0, $655Fc.localeStringToFloat)(value), (0, $655Fc.localeStringToFloat)(maxValue)) ? '' : `${(0, $daEfo.t9n)('emailValidator.maxValue')} ${maxValue}`;
const $c848bb82e2af39d0$export$85e9422a5732c151 = (email)=>(0, $3cM09.isEmailValidator)(email) ? '' : (0, $daEfo.t9n)('emailValidator.incorrectEmail');
const $c848bb82e2af39d0$export$5fe07b64a9ea357e = (password)=>(0, $3cM09.isPasswordValidator)(password) ? '' : (0, $daEfo.t9n)('emailValidator.toShortPassword');
const $c848bb82e2af39d0$export$c6a00b1b1a7803e7 = (averageRate, errorMessage)=>{
    if (!averageRate || averageRate <= 0) return errorMessage ?? (0, $daEfo.t9n)('emailValidator.minValue');
    return '';
};

});
parcelRegister("3cM09", function(module, exports) {
"use strict";
var $2557ba2a47648495$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2557ba2a47648495$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2557ba2a47648495$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2557ba2a47648495$var$__exportStar((parcelRequire("dMzC4")), module.exports);

$2557ba2a47648495$var$__exportStar((parcelRequire("6a6TF")), module.exports);

});
parcelRegister("dMzC4", function(module, exports) {
"use strict";
/** @module Patterns */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isStreetPattern = module.exports.isPostalCodePattern = module.exports.isCharsCompanyPattern = module.exports.isBankAccountNamePattern = module.exports.isPasswordPattern = module.exports.isNumericPattern = module.exports.isNipPattern = module.exports.isNamePattern = module.exports.isLastNamePattern = module.exports.isGenericTextPattern = module.exports.isCityPattern = module.exports.isAlphaNumericPattern = module.exports.isAccountTypeOtherPattern = module.exports.isAccountNumberPattern = void 0;
var $a08b62134a7a893c$var$isAccountNumberPattern = function isAccountNumberPattern(value) {
    var pattern = '^[a-zA-Z0-9\\s]*$';
    return !!value.match(pattern);
};
module.exports.isAccountNumberPattern = $a08b62134a7a893c$var$isAccountNumberPattern;
/**
 * Checks if value matches account number pattern
 * <pre> /^[a-zA-Z0-9\\s]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isAccountTypeOtherPattern = function isAccountTypeOtherPattern(value) {
    var pattern = "^[a-zA-Z\u0105\u0107\u0119\u0142\u0144\xf3\u015B\u017A\u017C\u0104\u0106\u0118\u0141\u0143\xd3\u015A\u0179\u017B. ]*$";
    return !!value.match(pattern);
};
module.exports.isAccountTypeOtherPattern = $a08b62134a7a893c$var$isAccountTypeOtherPattern;
/**
 * Checks if value matches account type pattern
 * <pre> /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ. ]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isAlphaNumericPattern = function isAlphaNumericPattern(value) {
    var pattern = '^[a-zA-Z0-9]*$';
    return !!value.match(pattern);
};
module.exports.isAlphaNumericPattern = $a08b62134a7a893c$var$isAlphaNumericPattern;
/**
 * Checks if value matches alpha numeric pattern
 * <pre> /^[a-zA-Z0-9]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isCityPattern = function isCityPattern(value) {
    var pattern = "^([a-zA-Z\x80-\u024F]+(?:. |-| |'))*[a-zA-Z\x80-\u024F]*$";
    return !!value.match(pattern);
};
module.exports.isCityPattern = $a08b62134a7a893c$var$isCityPattern;
/**
 * Checks if value matches city pattern
 * <pre> /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isGenericTextPattern = function isGenericTextPattern(value) {
    var pattern = "^[0-9a-zA-Z\u0105\u0107\u0119\u0142\u0144\xf3\u015B\u017A\u017C\u0104\u0106\u0118\u0141\u0143\xd3\u015A\u0179\u017B\\s\\,\\.\\-\\+\\(\\)\\!\\?\\:\\@\\n]*$";
    return !!value.match(pattern);
};
module.exports.isGenericTextPattern = $a08b62134a7a893c$var$isGenericTextPattern;
/**
 * Checks if value matches generic text pattern
 * <pre> /^[0-9a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s\,\.\-\+\(\)\!\?\:\@\n]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isLastNamePattern = function isLastNamePattern(value) {
    var pattern = "^[a-zA-Z\\u00C0-\\u017F\\-\\s\\']*$";
    return !!value.match(pattern);
};
module.exports.isLastNamePattern = $a08b62134a7a893c$var$isLastNamePattern;
/**
 * Checks if value matches last name pattern
 * <pre> /^[a-zA-Z\u00C0-\u017F\-\s\']*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isNamePattern = function isNamePattern(value) {
    var pattern = "^[a-zA-Z\u0105\u0107\u0119\u0142\u0144\xf3\u015B\u017A\u017C\u0104\u0106\u0118\u0141\u0143\xd3\u015A\u0179\u017B ]*$";
    return !!value.match(pattern);
};
module.exports.isNamePattern = $a08b62134a7a893c$var$isNamePattern;
/**
 * Checks if value matches name pattern
 * <pre> /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ ]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isNipPattern = function isNipPattern(value) {
    var pattern = '^[a-zA-Z0-9\\s\\-]*$';
    return !!value.match(pattern);
};
module.exports.isNipPattern = $a08b62134a7a893c$var$isNipPattern;
/**
 * Checks if value matches nip pattern
 * <pre> /^[a-zA-Z0-9\s\-]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isNumericPattern = function isNumericPattern(value) {
    var pattern = '^[0-9]*$';
    return !!value.match(pattern);
};
module.exports.isNumericPattern = $a08b62134a7a893c$var$isNumericPattern;
/**
 * Checks if value matches numeric pattern
 * <pre> /^[0-9]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isPasswordPattern = function isPasswordPattern(value) {
    var pattern = "^[0-9a-zA-Z\u0105\u0107\u0119\u0142\u0144\xf3\u015B\u017A\u017C\u0104\u0106\u0118\u0141\u0143\xd3\u015A\u0179\u017B\\s\\-\\+\\_\\\\!\\@\\#\\$\\%\\^&\\*\\|\\\"\\'\\;\\:\\,\\.\\?\\(\\)\\[\\]\\{\\}]*$";
    return !!value.match(pattern);
};
module.exports.isPasswordPattern = $a08b62134a7a893c$var$isPasswordPattern;
/**
 * Checks if value matches password pattern
 * <pre> /^[0-9a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ\s\-\+\_\\!\@\#\$\%\^&\*\|\"\'\;\:\,\.\?\(\)\[\]\{\}]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isBankAccountNamePattern = function isBankAccountNamePattern(value) {
    var pattern = "^[0-9a-zA-Z\\u00C0-\\u017F\\xad\\xa0\\u201c\\u201d\\u201e\u201F\\u2013\\_\\;\\'\\@\\-\\s\\\",.\\/\\-\\+\\&\\(\\)]*$";
    return !!value.match(pattern);
};
module.exports.isBankAccountNamePattern = $a08b62134a7a893c$var$isBankAccountNamePattern;
/**
 * Checks if value matches bank account name pattern
 * <pre>
 *   /^[0-9a-zA-Z\u00C0-\u017F\xad\xa0\u201c\u201d\u201e\u201f\u2013\_\;\'\@\-\s\",.\/\-\+\&\(\)]*$/
 * </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isCharsCompanyPattern = function isCharsCompanyPattern(value) {
    var pattern = "^[a-zA-Z0-9\\u00C0-\\u017F\\xad\\xa0\\u201c\\u201d\\u201e\u201F\\u2013\\_\\;\\@\\-\\s\\.\\,\\&\\`\\'\\:\\(\\)\\!\\*\\\"\\/\\\\\\+]*$";
    return !!value.match(pattern);
};
module.exports.isCharsCompanyPattern = $a08b62134a7a893c$var$isCharsCompanyPattern;
/**
 * Checks if value matches company name pattern
 * <pre>
 *   /^[a-zA-Z0-9\u00C0-\u017F\xad\xa0\u201c\u201d\u201e\u201f\u2013\_\;\@\-\s\.\,\&\`\'\:\(\)\!\*\"\/\\\+]*$/
 * </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isPostalCodePattern = function isPostalCodePattern(value) {
    var pattern = '^[a-zA-Z0-9 \\-]*$';
    return !!value.match(pattern);
};
module.exports.isPostalCodePattern = $a08b62134a7a893c$var$isPostalCodePattern;
/**
 * Checks if value matches postal code pattern
 * <pre> /^[a-zA-Z0-9 \-]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $a08b62134a7a893c$var$isStreetPattern = function isStreetPattern(value) {
    var pattern = "^[0-9a-zA-Z\\u00C0-\\u017F\\-\\s\\.,\\/]*$";
    return !!value.match(pattern);
};
module.exports.isStreetPattern = $a08b62134a7a893c$var$isStreetPattern; /**
 * Checks if value matches street name pattern
 * <pre> /^[0-9a-zA-Z\u00C0-\u017F\-\s\.,\/]*$/ </pre>
 * @param {string} value - value to check.
 * @returns {boolean}
 */ 

});

parcelRegister("6a6TF", function(module, exports) {
"use strict";
/** @module General Validators */ var $47c906d6984dd304$var$__importDefault = function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isLatinValidator = module.exports.isAllKeysValidator = module.exports.isPropValidator = module.exports.isPassportValidator = module.exports.isIdNumberValidator = module.exports.isSwiftCountryValidator = module.exports.isSwiftValidator = module.exports.isLanNumberValidator = module.exports.isIbanLengthValidator = module.exports.isIbanValidator = module.exports.isOtherThanValidator = module.exports.isSameAsValidator = module.exports.isMaxLengthValidator = module.exports.isMinLengthValidator = module.exports.isEmailValidator = module.exports.isNotHigherOrEqualValidator = module.exports.isNotHigherValidator = module.exports.isNotSmallerOrEqualValidator = module.exports.isNotSmallerValidator = module.exports.isPasswordValidator = module.exports.isPostalCodeValidator = module.exports.isNipValidator = module.exports.isSelectedValidator = module.exports.isNotEmptyTrimmedStringValidator = module.exports.isNotEmptyStringValidator = module.exports.isNotEmptyUnlessValidator = module.exports.isNotUndefinedValidator = module.exports.isNotNullValidator = module.exports.isValueValidator = void 0;

var $54HQr = parcelRequire("54HQr");

var $47c906d6984dd304$var$value_of_letter_1 = $47c906d6984dd304$var$__importDefault((parcelRequire("c9uu9")));
var $47c906d6984dd304$var$isValueValidator = function isValueValidator(value) {
    return !!value;
};
module.exports.isValueValidator = $47c906d6984dd304$var$isValueValidator;
/**
 * Checks if any proper value was given
 * @param {any} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotNullValidator = function isNotNullValidator(value) {
    return value !== null;
};
module.exports.isNotNullValidator = $47c906d6984dd304$var$isNotNullValidator;
/**
 * Checks if value is not null
 * @param {any} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotUndefinedValidator = function isNotUndefinedValidator(value) {
    return value !== undefined;
};
module.exports.isNotUndefinedValidator = $47c906d6984dd304$var$isNotUndefinedValidator;
/**
 * Checks if value is not undefined
 * @param {any} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotEmptyUnlessValidator = function isNotEmptyUnlessValidator(value, canBeEmpty) {
    return canBeEmpty ? true : !!value;
};
module.exports.isNotEmptyUnlessValidator = $47c906d6984dd304$var$isNotEmptyUnlessValidator;
/**
 * Checks if value was given unless can be empty.
 * @param {string} value - value to check.
 * @param {boolean} canBeEmpty - if true validation is ignored
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotEmptyStringValidator = function isNotEmptyStringValidator(value) {
    return value !== '';
};
module.exports.isNotEmptyStringValidator = $47c906d6984dd304$var$isNotEmptyStringValidator;
/**
 * Checks if value is not empty string
 * @param {any} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotEmptyTrimmedStringValidator = function isNotEmptyTrimmedStringValidator(value) {
    return value.trim() !== '';
};
module.exports.isNotEmptyTrimmedStringValidator = $47c906d6984dd304$var$isNotEmptyTrimmedStringValidator;
/**
 * Checks if value is not empty string after trim
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isSelectedValidator = function isSelectedValidator(value) {
    return module.exports.isNotNullValidator(value) && module.exports.isNotUndefinedValidator(value) && value !== '' && value !== '?' && value !== '? string: ?' && value !== '? boolean: ?' && value !== '? undefined:undefined ?';
};
module.exports.isSelectedValidator = $47c906d6984dd304$var$isSelectedValidator;
/**
 * Checks if any option was chosen. Created for select2 library
 * @param {(string| boolean)} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNipValidator = function isNipValidator(value) {
    var weights = [
        6,
        5,
        7,
        2,
        3,
        4,
        5,
        6,
        7
    ];
    var nip = value.replace(/[\s-]|PL/g, '');
    var zip = function zip(rows) {
        return rows[0].map(function(_, c) {
            return rows.map(function(row) {
                return row[c];
            });
        });
    };
    if (nip.length === 10 && parseInt(nip, 10) > 0) {
        var zippedNip = zip([
            weights,
            nip.slice(0, 9)
        ]);
        var sum = zippedNip.map(function(_a) {
            var weight = _a[0], n = _a[1];
            return weight * n;
        }).reduce(function(a, b) {
            return a + b;
        }, 0);
        return sum % 11 === parseInt(nip[9], 10);
    }
    return false;
};
module.exports.isNipValidator = $47c906d6984dd304$var$isNipValidator;
/**
 * Checks if value is valid nip number
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isPostalCodeValidator = function isPostalCodeValidator(value, country) {
    return country === 'PL' ? !!value.match(/^\d{2}\-?\d{3}$/) && value !== '00-000' && value !== '00000' : country === 'CN' ? !!value.match(/^[0-9]{1,6}$/) : true;
};
module.exports.isPostalCodeValidator = $47c906d6984dd304$var$isPostalCodeValidator;
/**
 * Checks if value is valid polish or chinese postal code
 * @param {string} value - value to check.
 * @param {string} country - country of postal code.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isPasswordValidator = function isPasswordValidator(value) {
    return !!value.match(/^.{8,}$/);
};
module.exports.isPasswordValidator = $47c906d6984dd304$var$isPasswordValidator;
/**
 * Checks if value is valid password with 8 signs
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotSmallerValidator = function isNotSmallerValidator(value, minValue) {
    return value && parseFloat(value) >= parseFloat(minValue);
};
module.exports.isNotSmallerValidator = $47c906d6984dd304$var$isNotSmallerValidator;
/**
 * Checks if value is smaller than given minimal value
 * @param {string} value - value to check.
 * @param {string} minValue - minimal value.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotSmallerOrEqualValidator = function isNotSmallerOrEqualValidator(value, minValue) {
    return value && parseFloat(value) > parseFloat(minValue);
};
module.exports.isNotSmallerOrEqualValidator = $47c906d6984dd304$var$isNotSmallerOrEqualValidator;
/**
 * Checks if value is smaller or equal than given minimal value
 * @param {string} value - value to check.
 * @param {string} minValue - minimal value.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotHigherValidator = function isNotHigherValidator(value, maxValue) {
    return value && parseFloat(value) <= parseFloat(maxValue);
};
module.exports.isNotHigherValidator = $47c906d6984dd304$var$isNotHigherValidator;
/**
 * Checks if value is higher than given maximal value
 * @param {string} value - value to check.
 * @param {string} maxValue - maximal value.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isNotHigherOrEqualValidator = function isNotHigherOrEqualValidator(value, maxValue) {
    return value && parseFloat(value) < parseFloat(maxValue);
};
module.exports.isNotHigherOrEqualValidator = $47c906d6984dd304$var$isNotHigherOrEqualValidator;
/**
 * Checks if value is higher or equal than given maximal value
 * @param {string} value - value to check.
 * @param {string} maxValue - maximal value.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isEmailValidator = function isEmailValidator(value) {
    return value ? !!value.match(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i) : true;
};
module.exports.isEmailValidator = $47c906d6984dd304$var$isEmailValidator;
/**
 * Checks if value is valid email. Based on w3.org
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isMinLengthValidator = function isMinLengthValidator(value, minLength) {
    return value && value.length >= minLength;
};
module.exports.isMinLengthValidator = $47c906d6984dd304$var$isMinLengthValidator;
/**
 * Checks if value has smaller or equal length than given minimal length
 * @param {string} value - value to check.
 * @param {string} minLength - minimal length.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isMaxLengthValidator = function isMaxLengthValidator(value, maxLength) {
    return value && value.length <= maxLength;
};
module.exports.isMaxLengthValidator = $47c906d6984dd304$var$isMaxLengthValidator;
/**
 * Checks if value has bigger or equal length than given maximal length
 * @param {string} value - value to check.
 * @param {string} maxLength - maximal length.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isSameAsValidator = function isSameAsValidator(value, otherValue) {
    return value === otherValue;
};
module.exports.isSameAsValidator = $47c906d6984dd304$var$isSameAsValidator;
/**
 * Checks if value is equal to other value
 * @param {string} value - value to check.
 * @param {string} otherValue - other value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isOtherThanValidator = function isOtherThanValidator(value, otherValue) {
    return value !== otherValue;
};
module.exports.isOtherThanValidator = $47c906d6984dd304$var$isOtherThanValidator;
/**
 * Checks if value is not equal to other value
 * @param {string} value - value to check.
 * @param {string} otherValue - other value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isIbanValidator = function isIbanValidator(value, countryCode) {
    return $54HQr.ibanHelper.checkIban(value, countryCode);
};
module.exports.isIbanValidator = $47c906d6984dd304$var$isIbanValidator;
/**
 * Checks if value is valid iban number
 * @param {string} value - value to check.
 * @param {CountryCode} countryCode - country code.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isIbanLengthValidator = function isIbanLengthValidator(value, countryCode) {
    return $54HQr.ibanHelper.checkIbanLength(value, countryCode);
};
module.exports.isIbanLengthValidator = $47c906d6984dd304$var$isIbanLengthValidator;
/**
 * Checks if value is valid iban number
 * @param {string} value - value to check.
 * @param {CountryCode} countryCode - country code.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isLanNumberValidator = function isLanNumberValidator(value, country) {
    var lanCountriesRules = {
        AU: /^[A-Za-z0-9]{6,30}$/,
        CA: /^[A-Za-z0-9]{7,15}$/,
        CN: /^(?:OSA|NRA|FTN)?[A-Z0-9]{1,22}$/i,
        JP: /^[A-Za-z0-9]{8,14}$/,
        KR: /^[A-Za-z0-9]{11,16}$/,
        NZ: /^[A-Za-z0-9]{15,16}$/,
        SG: /^[A-Za-z0-9]{1,14}$/,
        TW: /^[A-Za-z0-9]{1,22}$/,
        US: /^[A-Za-z0-9]{10,30}$/
    };
    var defaultRule = /^[A-Za-z0-9]{1,22}$/;
    return !!value.replace(/ /g, '').match(lanCountriesRules[country] ? lanCountriesRules[country] : defaultRule);
};
module.exports.isLanNumberValidator = $47c906d6984dd304$var$isLanNumberValidator;
/**
 * Checks if value is valid non-iban account number
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isSwiftValidator = function isSwiftValidator(value) {
    return !!value.match(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/i);
};
module.exports.isSwiftValidator = $47c906d6984dd304$var$isSwiftValidator;
/**
 * Checks if value is valid swift number
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isSwiftCountryValidator = function isSwiftCountryValidator(swift, country) {
    var swiftCountry = swift.substr(4, 2);
    return !country ? true : country === 'CN' ? [
        'CN',
        'HK',
        'MO'
    ].includes(swiftCountry) : swiftCountry === country;
};
module.exports.isSwiftCountryValidator = $47c906d6984dd304$var$isSwiftCountryValidator;
/**
 * Checks if given country is equal to country taken from swift
 * @param {string} swift - swift to check.
 * @param {string} country - country to compare.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isIdNumberValidator = function isIdNumberValidator(value) {
    var idNumberWeights = [
        7,
        3,
        1,
        9,
        7,
        3,
        1,
        7,
        3
    ];
    function checkIdNumber(id) {
        var controlSum = 0;
        for(var i = 0; i < id.length; i++)controlSum += i < 3 ? $47c906d6984dd304$var$value_of_letter_1.default(id[i]) * idNumberWeights[i] : parseInt(id[i], 10) * idNumberWeights[i];
        return controlSum % 10;
    }
    function isValid(id) {
        var parsedValue = id.replace(/ /g, '');
        return checkIdNumber(parsedValue) === 0 && parsedValue.length === 9;
    }
    return isValid(value);
};
module.exports.isIdNumberValidator = $47c906d6984dd304$var$isIdNumberValidator;
/**
 * Checks if value is valid polish id number
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isPassportValidator = function isPassportValidator(value) {
    var passportNumberWeights = [
        7,
        3,
        9,
        1,
        7,
        3,
        1,
        7,
        3
    ];
    function checkPassportNumber(passport) {
        var controlSum = 0;
        for(var i = 0; i < passport.length; i++)controlSum += i < 2 ? $47c906d6984dd304$var$value_of_letter_1.default(passport[i]) * passportNumberWeights[i] : parseInt(passport[i], 10) * passportNumberWeights[i];
        return controlSum % 10;
    }
    return checkPassportNumber(value) === 0 && value.length === 9;
};
module.exports.isPassportValidator = $47c906d6984dd304$var$isPassportValidator;
/**
 * Checks if value is valid polish passport number
 * @param {string} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isPropValidator = function isPropValidator(validObject) {
    return !!validObject.valid;
};
module.exports.isPropValidator = $47c906d6984dd304$var$isPropValidator;
/**
 * Checks if given object has property valid and if it is equal to true
 * @param {{valid: boolean}} value - value to check.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isAllKeysValidator = function isAllKeysValidator(object, expectedKeys) {
    return expectedKeys.every(function(val) {
        return Object.keys(object).includes(val);
    });
};
module.exports.isAllKeysValidator = $47c906d6984dd304$var$isAllKeysValidator;
/**
 * Checks if given object has all keys
 * @param {object} object - value to check.
 * @param {string[]} expectedKeys - array of expected keys.
 * @returns {boolean}
 */ var $47c906d6984dd304$var$isLatinValidator = function isLatinValidator(value) {
    return !!value.match(/^(?:[\t-\r -~\xA0-\xA9\xAB\xAC\xAE-\xB1\xB4\xB6-\xB8\xBB\xBF-\u017F\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u037E\u0384\u0385\u0387\u03F6\u0482\u055A-\u055F\u0589\u058A\u058D-\u058F\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0606-\u060F\u061B\u061E\u061F\u066A-\u066D\u06D4\u06DE\u06E9\u06FD\u06FE\u0700-\u070D\u07F6-\u07F9\u07FE\u07FF\u0830-\u083E\u085E\u0964\u0965\u0970\u09F2\u09F3\u09FA\u09FB\u09FD\u0A76\u0AF0\u0AF1\u0B70\u0BF3-\u0BFA\u0C77\u0C7F\u0C84\u0D4F\u0D79\u0DF4\u0E3F\u0E4F\u0E5A\u0E5B\u0F01-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0F3A-\u0F3D\u0F85\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FDA\u104A-\u104F\u109E\u109F\u10FB\u1360-\u1368\u1390-\u1399\u1400\u166D\u166E\u1680\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DB\u1800-\u180A\u1940\u1944\u1945\u19DE-\u19FF\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B6A\u1B74-\u1B7C\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u1E9E\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2000-\u200A\u2010-\u2029\u202F-\u205F\u207A-\u207E\u208A-\u208E\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129-\u212B\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2775\u2794-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E52\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3000-\u3004\u3008-\u3020\u3030\u3036\u3037\u303D-\u303F\u309B\u309C\u30A0\u30FB\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAA77-\uAA79\uAADE\uAADF\uAAF0\uAAF1\uAB5B\uAB6A\uAB6B\uABEB\uFB29\uFBB2-\uFBC1\uFD3E\uFD3F\uFDFC\uFDFD\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFEFF\uFF01-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD00-\uDD02\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDC77\uDC78\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEC8\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3F]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFD5-\uDFF1\uDFFF]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3F\uDF44\uDF45]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F[\uDC9C\uDC9F]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85-\uDE8B]|\uD838[\uDD4F\uDEFF]|\uD83A[\uDD5E\uDD5F]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA])+$/i);
};
module.exports.isLatinValidator = $47c906d6984dd304$var$isLatinValidator; /**
 * Checks if value is in Latin alphabet
 * or matches any kind of punctuation character
 * or matches any math symbols, currency signs, dingbats, box-drawing characters, etc
 * @param {string} value - value to check.
 * @returns {boolean}
 */ 

});
parcelRegister("54HQr", function(module, exports) {
"use strict";
var $3b1f562ac2636173$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3b1f562ac2636173$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3b1f562ac2636173$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3b1f562ac2636173$var$__exportStar((parcelRequire("gXzp5")), module.exports);

});
parcelRegister("gXzp5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ibanHelper = void 0;
module.exports.ibanHelper = {
    getCurrentCountryCode: function(iban) {
        return iban && iban.substr(0, 2).replace(/\d/g, '');
    },
    sanitize: function(iban) {
        return iban ? iban.replace(/\s/g, '') : null;
    },
    checkIbanLength: function(accountNumber, countryCode) {
        var sanitizedNumber = accountNumber.replace(/ /g, '');
        var isPrefix = sanitizedNumber.substr(0, 2).match(/[A-Z]/i);
        return countryCode === 'PL' && isPrefix && sanitizedNumber.length === 28 || countryCode === 'PL' && !isPrefix && sanitizedNumber.length === 26 || countryCode !== 'PL' && sanitizedNumber.length > 12;
    },
    checkIban: function(iban, countryCode) {
        iban = iban.toUpperCase().replace(/ /g, '');
        if (iban.length < 4) return false;
        // If country code is given, country code in iban should be the same as the given one
        // Or if there is no country code in iban, we add the given one
        if (countryCode) {
            var currentCountryCode = module.exports.ibanHelper.getCurrentCountryCode(iban);
            if (currentCountryCode) {
                if (currentCountryCode !== countryCode) return false;
            } else iban = "" + countryCode + iban;
        }
        iban = iban.substr(4) + iban.substr(0, 4);
        var num = '';
        for(var i in iban)if (iban.hasOwnProperty(i)) {
            var c = iban[i];
            if (c >= '0' && c <= '9') num += c;
            else if (c >= 'A' && c <= 'Z') num += "" + (c.charCodeAt(0) - 55);
            else return false;
        }
        return module.exports.ibanHelper.iso7064Mod97_10(num) === 1;
    },
    iso7064Mod97_10: function(iban) {
        var remainder = iban;
        var block;
        while(remainder.length > 2){
            block = remainder.slice(0, 9);
            remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
        }
        return parseInt(remainder, 10) % 97;
    },
    getCompleteIban: function(iban, countryCode) {
        if (countryCode && iban) {
            var currentCountryCode = module.exports.ibanHelper.getCurrentCountryCode(iban);
            if (!currentCountryCode) iban = "" + countryCode + iban;
        }
        return module.exports.ibanHelper.sanitize(iban);
    }
};

});


parcelRegister("c9uu9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $8d8df90ed17471a8$var$valueOfLetter(value) {
    return value.toUpperCase().charCodeAt(0) - 55;
}
module.exports.default = $8d8df90ed17471a8$var$valueOfLetter;

});



parcelRegister("655Fc", function(module, exports) {

$parcel$export(module.exports, "isLongRateCurrencyPair", function () { return $4deb626e9469a145$export$e2b42627222f6cd7; });
$parcel$export(module.exports, "formatNumber", function () { return $4deb626e9469a145$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberWithSep", function () { return $4deb626e9469a145$export$710facbbc6508700; });
$parcel$export(module.exports, "formatRate", function () { return $4deb626e9469a145$export$5ad9f64d1b96353b; });
$parcel$export(module.exports, "localeStringToFloat", function () { return $4deb626e9469a145$export$84e0d3817270b90b; });
/**
 * Utility functions for formatting numbers, particularly for currency exchange rates.
 * This module provides functions to format numbers with specific decimal places,
 * add thousands separators, and handle locale-specific number formats.
 */ // List of currency pairs that require higher precision (6 decimal places) when formatting exchange rates.
const $4deb626e9469a145$export$ac094b522c5cdff3 = [
    'HUF_PLN',
    'JPY_PLN'
];
const $4deb626e9469a145$export$e2b42627222f6cd7 = (pair)=>$4deb626e9469a145$export$ac094b522c5cdff3.includes(pair);
const $4deb626e9469a145$export$f5dd818bff069720 = (num, fractionDigits)=>{
    const numString = num.toString().replace(',', '.');
    const numberValue = parseFloat(numString);
    let valueToFormat = numberValue;
    if (isNaN(valueToFormat)) valueToFormat = 0;
    const fixedString = valueToFormat.toFixed(fractionDigits);
    return fixedString.replace('.', ',');
};
const $4deb626e9469a145$export$710facbbc6508700 = (num, fractionDigits = 2)=>{
    const formatted = $4deb626e9469a145$export$f5dd818bff069720(num, fractionDigits);
    const parts = formatted.split(',');
    const intPart = parts[0];
    const decimalPart = parts[1];
    const intPartFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
    if (decimalPart !== undefined) return `${intPartFormatted},${decimalPart}`;
    return intPartFormatted;
};
const $4deb626e9469a145$export$d12aa850cb262282 = (num)=>{
    const normalizedString = num.toString().replace(',', '.');
    const parsed = parseFloat(normalizedString);
    if (isNaN(parsed)) throw new Error('Invalid number format');
    const trimmedString = parsed.toString();
    const parts = trimmedString.split('.');
    const intPart = parts[0];
    const decimalPart = parts[1];
    const intPartFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
    if (decimalPart !== undefined) return `${intPartFormatted},${decimalPart}`;
    return intPartFormatted;
};
const $4deb626e9469a145$export$a6fc76f9a3a08d6a = (pair)=>{
    return $4deb626e9469a145$export$ac094b522c5cdff3.includes(pair) ? 6 : 4;
};
/**
 * Validates currency pair format.
 *
 * @param pair - The currency pair to validate
 * @returns true if the format is valid (XXX_YYY where X is uppercase letter)
 */ const $4deb626e9469a145$var$isValidCurrencyPairFormat = (pair)=>{
    return /^[A-Z]{3}_[A-Z]{3}$/.test(pair);
};
const $4deb626e9469a145$export$5ad9f64d1b96353b = (rate, pair)=>{
    if (!$4deb626e9469a145$var$isValidCurrencyPairFormat(pair)) throw new Error('Invalid currency pair format');
    const fractionDigits = $4deb626e9469a145$export$a6fc76f9a3a08d6a(pair);
    return $4deb626e9469a145$export$f5dd818bff069720(rate, fractionDigits);
};
const $4deb626e9469a145$export$84e0d3817270b90b = (value)=>value.trim().replace(/[^0-9,.-]/g, '') // Remove any non-numeric, non-comma, non-dot, non-dash characters
    .replace(/,/g, '.') // Replace commas with periods for decimal representation
;

});


parcelRegister("858k1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a115c2b963f0bd81$export$2e2bcd8739ae039; });

var $k0eal = parcelRequire("k0eal");
const $a115c2b963f0bd81$var$competitionSubscribe = (payload)=>{
    return (0, $k0eal.promiseWrapper)(`${USER_BASE_URL_IK}/api/public/cmsEmailSubscribe`, 'POST', payload);
};
var $a115c2b963f0bd81$export$2e2bcd8739ae039 = $a115c2b963f0bd81$var$competitionSubscribe;

});
parcelRegister("k0eal", function(module, exports) {

$parcel$export(module.exports, "promiseWrapper", function () { return $6e91e54d378b3a63$export$fb9752378c4199d7; });

var $75uJH = parcelRequire("75uJH");
function $6e91e54d378b3a63$export$fb9752378c4199d7(url, method, data, options, abortSignal) {
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.open(method, url);
        if (abortSignal) abortSignal.onabort = ()=>{
            xhr.abort();
            reject(new DOMException('Request cancelled', 'AbortError'));
        };
        if (method === 'POST' || method === 'PUT') xhr.setRequestHeader('Content-type', options?.contentType || 'application/json');
        if (options?.headers) Object.entries(options.headers).forEach(([key, value])=>{
            xhr.setRequestHeader(key, value);
        });
        if (options?.withCredentials) xhr.withCredentials = true;
        xhr.onload = ()=>{
            const responseData = xhr.response && (0, $75uJH.isJson)(xhr.response) ? JSON.parse(xhr.response) : xhr.response;
            if (xhr.status >= 200 && xhr.status < 300) resolve(responseData);
            else {
                const error = {
                    response: {
                        data: responseData,
                        status: xhr.status
                    }
                };
                reject(error);
            }
        };
        xhr.onerror = ()=>{
            reject({
                message: 'Network error or CORS issue',
                isNetworkError: true,
                statusText: xhr.statusText
            });
        };
        xhr.send(data ? options?.noJson ? data.toString() : JSON.stringify(data) : null);
    });
}

});
parcelRegister("75uJH", function(module, exports) {

$parcel$export(module.exports, "isJson", function () { return $8a49ef9d1a4be98f$export$952e1d8683e4d0c4; });
function $8a49ef9d1a4be98f$export$952e1d8683e4d0c4(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

});



parcelRegister("lljZm", function(module, exports) {

$parcel$export(module.exports, "checkEmailAvailability", function () { return $20e0660e5c25600c$export$91c06f3217089138; });

var $k0eal = parcelRequire("k0eal");
const $20e0660e5c25600c$export$91c06f3217089138 = (payload)=>{
    return (0, $k0eal.promiseWrapper)(`${USER_BASE_URL_IK}/api/public/emailAvailable/${payload.email}`, 'GET');
};

});

parcelRegister("a6hcg", function(module, exports) {

$parcel$export(module.exports, "signUpForNewsletter", function () { return $17e5dcfca0d85646$export$115ec547bc33484; });

var $k0eal = parcelRequire("k0eal");
function $17e5dcfca0d85646$export$115ec547bc33484(payload) {
    const { email: email, list: list = 'c' } = payload;
    return (0, $k0eal.promiseWrapper)(`${USER_BASE_URL_IK}/api/public/subscribe-to-newsletter`, 'POST', {
        email: email,
        list: list
    });
}

});



var $cV1uQ = parcelRequire("cV1uQ");

var $1QOFx = parcelRequire("1QOFx");

var $bRcVd = parcelRequire("bRcVd");
function $f50eade48f726e3c$var$init() {
    // set GA/GTM events tracking
    (0, $cV1uQ.spawnTrackingEventListners)();
    // handle hero form state
    (0, $1QOFx.handleHasAccountInputs)();
    // Competition Form
    //set true if registered mail is required
    //set true if answer is optional
    (0, $bRcVd.handleCompetitionForm)(true, false);
}
$f50eade48f726e3c$var$init();

})();
//# sourceMappingURL=script.js.map
